// Catalogo en. Generado a mano; el test de catalogos garantiza que los tres coinciden.
export default {
    'app.nombre': 'Soluxe Management',
    'app.cargando': 'Loading...',
    'app.guardar': 'Save',
    'app.si': 'Yes',
    'app.no': 'No',
    'app.anadir': 'Add',
    'app.cancelar': 'Cancel',
    'aj.subtitulo': 'Your company, your account and what notifies you.',
    'aj.organizacion': 'Organisation',
    'aj.organizacionPie': 'Tax identity and address',
    'aj.marca': 'Brand and appearance',
    'aj.marcaPie': 'Colours and logos',
    'aj.categorias': 'Expense categories',
    'aj.categoriasPie': 'The company\'s expense plan',
    'aj.notificaciones': 'Notifications',
    'aj.notificacionesPie': 'What notifies you on your device',
    'aj.seguridad': 'Security',
    'aj.seguridadPie': 'Password, passkeys and two-factor',
    'aj.integraciones': 'Integrations',
    'aj.integracionesPie': 'Keys for external services',
    'aj.apartados': 'Settings sections',
    'aj.identidad': 'Identity',
    'aj.faltanDatos': 'Invoice details missing',
    'aj.identidadPie': 'The trading name is what your team sees. The legal name and tax ID are what go on the invoice.',
    'aj.nombreComercial': 'Trading name',
    'aj.nombreComercialPie': 'The one shown in the menu and in reports.',
    'aj.razonSocial': 'Legal name',
    'aj.razonSocialPie': 'The company\'s registered name.',
    'aj.nif': 'Tax ID',
    'aj.nifPie': 'Stored without spaces or dashes.',
    'aj.domicilio': 'Registered address',
    'aj.domicilioPie': 'The address that will appear on the invoices you issue.',
    'aj.direccion': 'Address',
    'aj.codigoPostal': 'Postcode',
    'aj.poblacion': 'Town or city',
    'aj.provincia': 'Province',
    'aj.pais': 'Country',
    'aj.colores': 'Colours',
    'aj.coloresPie': 'They apply to the app and to the documents it produces. Status colours — green, amber, red — do not change: they say whether something is fine or not, and that is not a matter of branding.',
    'aj.colorAcento': 'Accent colour',
    'aj.colorAcentoPie': 'Buttons, links and highlights',
    'aj.colorCabecera': 'Header colour',
    'aj.colorCabeceraPie': 'Header and sidebar',
    'aj.colorSecundario': 'Secondary colour',
    'aj.colorSecundarioPie': 'Labels and details',
    'aj.hexadecimal': '{campo} in hexadecimal',
    'aj.logotipos': 'Logos',
    'aj.logotiposPie': 'One for a dark background and one for a light one: the same logo does not read well on both.',
    'aj.sobreOscuro': 'On a dark background',
    'aj.sobreClaro': 'On a light background',
    'aj.sinLogotipo': 'No logo',
    'aj.subir': 'Upload',
    'aj.cambiar': 'Replace',
    'aj.subiendo': 'Uploading…',
    'aj.quitar': 'Remove',
    'aj.vistaPrevia': 'Preview',
    'aj.vistaPreviaPie': 'Changes show up here straight away. Press “Save” to keep them.',
    'aj.dePropiedad': 'Property',
    'aj.dePropiedadPie': 'The ones offered when logging an expense for a house; these are what the owner sees in their portal.',
    'aj.internas': 'Internal',
    'aj.internasPie': 'The organisation’s own expenses, the ones not charged to any property.',
    'aj.categoriasPie2': 'Add, rename or deactivate your organisation’s categories. Deactivating one stops it being offered when logging; expenses already using it still count.',
    'aj.sistema': 'System',
    'aj.nGastos': '{total} expenses',
    'aj.unGasto': '1 expense',
    'aj.activa': 'Active',
    'aj.oculta': 'Hidden',
    'aj.activaAyuda': 'Offered when logging an expense',
    'aj.ocultaAyuda': 'Hidden when logging',
    'aj.borrar': 'Delete',
    'aj.anadirCategoria': 'Add category',
    'aj.nombreCategoria': 'Category name',
    'aj.ambito': 'Category scope',
    'aj.nombreDe': 'Name of {nombre}',
    'aj.avisosPie': 'Choose what notifies you on your device. All notices still appear in the app’s bell, regardless of this.',
    'avisosMovil.titulo': 'Alerts on this device',
    'avisosMovil.encendido': 'On. You will get them even with the app closed.',
    'avisosMovil.apagado': 'Off on this device.',
    'avisosMovil.denegado': 'The browser has them blocked. Turn them on in the system settings for this app.',
    'avisosMovil.noSoportado': 'This browser does not support them. On iPhone: add the app to the home screen and open it from there.',
    'avisosMovil.sinClave': 'Not configured on the server yet.',
    'avisosMovil.encender': 'Turn on',
    'avisosMovil.apagar': 'Turn off',
    'avisosMovil.noSePudo': 'Alerts could not be turned on for this device.',
    'avisosMovil.instalar': 'One step missing: on iPhone, notifications only work with the app added to the home screen.',
    'avisosMovil.paso1': 'Open this page in Safari and tap the Share button (the square with the up arrow).',
    'avisosMovil.paso2': 'Choose “Add to Home Screen” and confirm.',
    'avisosMovil.paso3': 'Open SOLUXE from the new icon, come back here and tap Enable.',
    'avisosMovil.ninguno': 'The server has no device registered for you. Until there is one, no notification can go out.',
    'avisosMovil.dispositivoSinNombre': 'Device',
    'avisosMovil.este': 'this one',
    'avisosMovil.ultimo': 'Last notification received on {fecha}',
    'avisosMovil.nuncaRecibio': 'Has not received any yet',
    'avisosMovil.conFallos': 'failures in a row: {n}',
    'avisosMovil.probar': 'Send me a test',
    'avisosMovil.probando': 'Sending…',
    'avisosMovil.entregado': 'Delivered to {dispositivo}. If it did not ring, check System Settings → Notifications → SOLUXE.',
    'avisosMovil.rechazado': '{dispositivo} rejected it ({codigo}). {motivo}',
    'aviso.CLIENTE_INCIDENCIA': 'The client reports an issue',
    'aviso.CLIENTE_INCIDENCIAPie': 'From their portal, the moment they write it',
    'aviso.CLIENTE_ESTANCIA': 'The client announces a stay',
    'aviso.CLIENTE_ESTANCIAPie': 'When they say they are coming, with their dates',
    'aviso.CLIENTE_MENSAJE': 'The client writes on an issue',
    'aviso.CLIENTE_MENSAJEPie': 'A message of theirs in the thread, waiting for an answer',
    'aviso.INCIDENCIA_RESUELTA': 'An issue is closed',
    'aviso.INCIDENCIA_RESUELTAPie': 'When someone on the team marks it resolved',
    'aviso.GASTO_ALTO': 'Large expense',
    'aviso.INCIDENCIA_NUEVA': 'New issue',
    'aviso.INCIDENCIA_NUEVAPie': 'An issue is opened on a property you look after',
    'aviso.RESPUESTA_EQUIPO': 'Reply from the team',
    'aviso.RESPUESTA_EQUIPOPie': 'We answer in an issue conversation',
    'aviso.ESTANCIA_NUEVA': 'Stay booked',
    'aviso.ESTANCIA_NUEVAPie': 'A stay is recorded for the property',
    'aviso.GASTO_ALTOPie': 'An expense above €100, and who logged it',
    'aviso.ASIGNADA_A_TI': 'An issue is assigned to you',
    'aviso.ASIGNADA_A_TIPie': 'When you are made responsible for solving it',
    'aviso.INCIDENCIA_CRITICA': 'Critical issues',
    'aviso.INCIDENCIA_CRITICAPie': 'When a top-urgency issue comes in (L1 or L2)',
    'aviso.VISITA_VENCIDA': 'Overdue visits',
    'aviso.VISITA_VENCIDAPie': 'A scheduled visit whose date passed without happening',
    'aviso.GASTO_PENDIENTE': 'Expenses to approve',
    'aviso.GASTO_PENDIENTEPie': 'Logged expenses waiting for your decision',
    'aviso.PAGO_RECURRENTE': 'Recurring payments',
    'aviso.PAGO_RECURRENTEPie': 'Fees and payments that come round every month',
    'aviso.FACTURA_VENCIDA': 'Overdue invoices',
    'aviso.FACTURA_VENCIDAPie': 'Issued invoices still unpaid',
    'aviso.MANTENIMIENTO_VENCIDO': 'Overdue maintenance',
    'aviso.MANTENIMIENTO_VENCIDOPie': 'Preventive jobs past their date',
    'aj.faceId': 'Registered passkeys',
    'aj.faceIdPie': 'You sign in with email and password, and your browser fills them in for you. Listed here are the passkeys you registered earlier: they no longer open a session, and you can remove them whenever you want.',
    'aj.dispositivo': 'Device',
    'aj.anadida': 'Added',
    'aj.ultimoUso': 'Last used',
    'aj.enLlavero': 'in your keychain',
    'aj.sinLlaves': 'You have no registered passkeys.',
    'aj.porQueQuitas': 'Why are you removing “{nombre}”?',
    'aj.motivoLlave': 'I no longer use that device',
    'aj.llaveRetirada': 'Passkey removed.',
    'aj.segundoFactor': 'Second factor',
    'aj.activo': 'On',
    'aj.inactivo': 'Off',
    'aj.dosFactoresActivo': 'Your account asks for a code as well as the password.',
    'aj.dosFactoresInactivo': 'Add one more layer to your sign-in.',
    'aj.activarDosFactores': 'Turn on second factor',
    'aj.codigoDesactivar': 'Code to turn it off',
    'aj.desactivar': 'Turn off',
    'aj.codigoConfirmar': 'Confirmation code',
    'aj.confirmar': 'Confirm',
    'aj.escanea': 'Scan it in your authenticator app (Google Authenticator, 1Password…), or enter the secret by hand. Then confirm with the code.',
    'aj.secreto': 'Secret',
    'aj.password': 'Your password',
    'aj.passwordPie': 'You are asked for the current one because an open session on a borrowed computer should not be enough to lock you out of your own account.',
    'aj.passwordActual': 'Current password',
    'aj.passwordNueva': 'New password',
    'aj.passwordRepetir': 'Repeat the new one',
    'aj.passwordCambiar': 'Change password',
    'aj.passwordCambiada': 'Password changed.',
    'aj.passwordNoCoincide': 'The two new passwords do not match.',
    'aj.passwordMinimo': 'At least 8 characters.',
    'auth.passwordCorta': 'The new password is too short.',
    'auth.passwordIgual': 'The new password is the same as the current one.',
    'auth.passwordActualMal': 'The current password is not correct.',
    'aj.guardar': 'Save',
    'aj.guardando': 'Saving…',
    'aj.guardado': 'Saved.',
    'aj.noSeCargo': 'Could not load.',
    'aj.noSeGuardo': 'Could not save.',
    'aj.empresa': 'Company',
    'portal.notificarIncidencia': 'Report a new issue',
    'portal.notificarVisita': 'Report a stay',
    'portal.ultimaVisita': 'Last visit',
    'portal.proximaVisitaCorta': 'Next visit',
    'portal.sinVisitas': 'No visits yet',
    'portal.urgencia': 'How urgent is it?',
    'portal.urgenciaPie': 'Tell us how you see it. The team reviews it and may adjust it.',
    'portal.anadirFotos': 'Add photos',
    'portal.cancelar': 'Cancel',
    'portal.tituloIncidencia': 'Title',
    'portal.editarPie': 'You can correct the title and description while the issue is still open.',
    'portal.noSeGuardo': 'The change could not be saved.',
    'portal.noSeSubio': 'The photo could not be uploaded.',
    'visor.cerrar': 'Close',
    'visor.abrirFuera': 'Open separately',
    'visor.cargando': 'Opening…',
    'visor.noSePudo': 'The file could not be opened.',
    'visor.noSeVePreview': 'This file cannot be shown here. Open it separately to download it.',
    'roto.titulo': 'This screen could not be drawn',
    'roto.explicacion': 'The rest of the app still works. Copy this detail and send it: it says exactly what failed.',
    'roto.copiar': 'Copy the detail',
    'roto.volver': 'Back to the dashboard',
    'app.volver': 'Back',
    'app.editar': 'Edit',
    'app.confirmar': 'Confirm',
    'app.consecuencias': 'Before you confirm, read what this means:',
    'auth.titulo': 'Sign in',
    'auth.email': 'Email address',
    'auth.password': 'Password',
    'auth.entrar': 'Sign in',
    'nav.ajustes': 'Settings',
    'nav.propiedades': 'Properties',
    'nav.panel': 'Dashboard',
    'integraciones.nota': 'Keys are encrypted when saved and never shown again: here you only see whether a service is connected.',
    'integraciones.conectada': 'Connected',
    'integraciones.sinConectar': 'Not connected',
    'integraciones.cambiar': 'Replace key',
    'integraciones.configurar': 'Set up',
    'integraciones.desconectar': 'Disconnect',
    'integraciones.clave': 'Key / token (secret)',
    'integraciones.clavePista': 'Encrypted on save; never shown again',
    'integraciones.etiqueta': 'Label (optional)',
    'nav.mas': 'More',
    'auth.salir': 'Sign out',
    'auth.error.credenciales': 'That email or password is not correct.',
    'auth.error.demasiadosIntentos': 'Too many attempts in a row. Wait a few minutes and try again.',
    'auth.error.sesionExpirada': 'Your session has expired. Please sign in again.',
    'auth.error.segundoFactor': 'The verification code is not correct.',
    'error.sinPermiso': 'You do not have permission to view this.',
    'error.gastoFacturado': 'This expense is already on an invoice: it cannot be changed or removed. Amend the invoice instead.',
    'error.responsableNoValido': 'That person cannot take it on: they must be an active team member.',
    'error.responsableSinAcceso': 'That person is not assigned to this property. Assign it to them in Users and try again.',
    'inc.responsable': 'Owner',
    'inc.titulo': 'Title',
    'inc.descripcion': 'Description',
    'inc.sinResponsable': 'No owner',
    'inc.elegirResponsable': 'Choose owner…',
    'inc.responsableNota': 'It shows in their “Today’s tasks” while the issue stays open.',
    'inc.sinAccesoCasa': 'no access to this property',
    'dia.asignada': 'Assigned',
    'error.noEncontrado': 'Not found.',
    'error.validacion': 'Please check the information you entered.',
    'error.servidor': 'Something went wrong. Please try again.',
    'error.configuracion': 'This feature is not configured yet.',
    'referido.estadoInvalido': 'The referral is not in a state that allows this action.',
    'propiedades.titulo': 'Properties',
    'propiedades.vacio': 'No properties yet.',
    'propiedades.codigo': 'Code',
    'propiedades.nombre': 'Name',
    'propiedades.zona': 'Area',
    'propiedades.estado': 'Status',
    'propiedades.propietarios': 'Owners',
    'propiedades.nio': 'Service level',
    'propiedades.semaforo': 'Operational status',
    'propiedades.requisitos': 'Outstanding requirements',
    'propiedades.sinRequisitos': 'Ready to activate',
    'propiedades.impideActivacion': 'This is what is missing before it can go live:',
    'propiedades.activar': 'Activate property',
    'propiedades.demoExcluida': 'excluded from metrics and from any real operation.',
    'propiedades.historial': 'History',
    'propiedades.relaciones': 'People and companies',
    'propiedades.contrato': 'Agreement',
    'propiedades.incidencias': 'Issues',
    'cartera.resumen': '{total} in total · {atencion} need attention',
    'cartera.buscar': 'Search by code, name or area',
    'cartera.ordenar': 'Sort',
    'cartera.ordenEstado': 'By status',
    'cartera.ordenNombre': 'By name',
    'cartera.ordenCodigo': 'By code',
    'cartera.verLista': 'List view',
    'cartera.verTarjetas': 'Card view',
    'cartera.sinTitular': 'No owner yet',
    'cartera.sinResultados': 'No properties match your search.',
    'cartera.limpiar': 'Clear search',
    'cartera.activas': '{total} active',
    'cartera.incidenciasAbiertas': 'Open incidents',
    'cartera.nueva': 'New property',
    'proveedores.titulo': 'Providers',
    'proveedores.resumen': '{total} active',
    'proveedores.nuevo': 'New provider',
    'proveedores.vacio': 'No providers in the directory yet.',
    'proveedores.nombre': 'Name',
    'proveedores.oficio': 'Trade',
    'proveedores.email': 'Email',
    'proveedores.telefono': 'Phone',
    'proveedores.nif': 'Tax ID',
    'proveedores.zona': 'Area',
    'proveedores.notas': 'Notes',
    'proveedores.guardar': 'Save provider',
    'proveedores.cancelar': 'Cancel',
    'proveedores.archivar': 'Archive',
    'proveedores.reactivar': 'Reactivate',
    'proveedores.archivado': 'Archived',
    'proveedores.verArchivados': 'Show archived',
    'proveedores.todos': 'All trades',
    'proveedores.sinContacto': 'No contact',
    'oficio.FONTANERIA': 'Plumbing',
    'oficio.JARDINERIA': 'Gardening',
    'oficio.CLIMA': 'HVAC',
    'oficio.PISCINAS': 'Pools',
    'oficio.LIMPIEZA': 'Cleaning',
    'oficio.ELECTRICIDAD': 'Electrical',
    'oficio.OBRA': 'Building works',
    'oficio.SEGURIDAD': 'Security',
    'oficio.OTRO': 'Other',
    'calendario.titulo': 'Calendar',
    'calendario.mes': 'Month',
    'calendario.anterior': 'Previous month',
    'calendario.siguiente': 'Next month',
    'calendario.hoy': 'Today',
    'calendario.todas': 'All properties',
    'calendario.nuevo': 'New event',
    'calendario.sinEventos': 'No events this month.',
    'calendario.mas': '+{total} more',
    'evento.VISITA': 'Visit',
    'evento.PREVENTIVA': 'Maintenance',
    'evento.REVISION': 'Review',
    'evento.LLEGADA': 'Arrival',
    'evento.SALIDA': 'Departure',
    'evento.OTRO': 'Other',
    'evento.tipo': 'Type',
    'evento.titulo': 'Title',
    'evento.fecha': 'Date',
    'evento.hora': 'Time',
    'evento.propiedad': 'Property',
    'evento.asignado': 'Assigned to',
    'evento.notas': 'Notes',
    'evento.sinPropiedad': 'No property',
    'evento.sinAsignar': 'Unassigned',
    'evento.guardar': 'Save event',
    'evento.marcarHecha': 'Mark as done',
    'evento.marcarCancelada': 'Cancel event',
    'evento.reabrir': 'Reopen',
    'evento.cerrar': 'Close',
    'evento.irPropiedad': 'Open property',
    'checklists.titulo': 'Checklist templates',
    'checklists.resumen': '{total} templates',
    'checklists.nuevaPlantilla': 'New template',
    'checklists.sinPlantillas': 'No templates yet.',
    'checklists.elige': 'Pick a template to see its items.',
    'checklists.itemsCorto': 'items',
    'checklists.criticos': 'Critical',
    'checklists.critico': 'Critical',
    'checklists.foto': 'Photo',
    'checklists.anadirItem': 'Add item',
    'checklists.seccion': 'Section',
    'checklists.texto': 'Item text',
    'checklists.guardar': 'Save',
    'checklists.cancelar': 'Cancel',
    'checklists.archivar': 'Archive',
    'checklists.reactivar': 'Reactivate',
    'checklists.archivada': 'Archived',
    'checklists.eliminar': 'Delete',
    'checklists.editar': 'Edit',
    'checklists.nombre': 'Name',
    'checklists.tipo': 'Type',
    'checklists.sinItems': 'This template has no items yet.',
    'checklistTipo.ENTRADA': 'Check-in',
    'checklistTipo.SALIDA': 'Check-out',
    'checklistTipo.PERIODICA': 'Periodic review',
    'checklistTipo.MANTENIMIENTO': 'Maintenance',
    'checklistTipo.OTRO': 'Other',
    'alertas.titulo': 'Notifications',
    'alertas.marcarLeidas': 'Mark as read',
    'alertas.sinLeer': '{total} unseen',
    'alertas.resumen': '{total} need your attention',
    'alertas.vacio': 'All clear. No alerts.',
    'alertas.incidencia': 'Open incident',
    'alertas.activacion': 'Activation pending',
    'alertas.requisitos': '{total} requirements pending',
    'alertaSeveridad.ALTA': 'High',
    'alertaSeveridad.MEDIA': 'Medium',
    'alertaSeveridad.BAJA': 'Low',
    'mapa.titulo': 'Activity map',
    'mapa.subtitulo': 'Where the portfolio is and what needs attention',
    'mapa.zona': 'Area',
    'mapa.todas': 'All areas',
    'mapa.esquema': 'Illustrative schematic: positions are not geographic.',
    'mapa.actividad': 'Properties with open incidents',
    'mapa.sinActividad': 'No open incidents in this selection.',
    'mapa.incidencias': '{total} open',
    'adjunto.noSeGuarda': 'The file could not be stored on the server.',
    'ficha.subiendoFoto': 'Uploading the photo...',
    'ficha.subirFoto': 'Choose a photo (JPEG, PNG or WEBP)',
    'ficha.subirFotoAyuda': 'Stored in the system. Removing the photo also deletes the file.',
    'ficha.anadirPorUrl': 'Add by address',
    'cobro.titulo': 'Collection',
    'cobro.POR_COBRAR': 'To invoice',
    'cobro.FACTURADO': 'Invoiced',
    'cobro.COBRADO': 'Paid',
    'adjunto.contenidoPerdido': 'The file is no longer in the store.',
    'inc.fotoNoSeVe': 'Cannot be displayed. Open or download',
    'interno.buscar': 'Search concept, person or description',
    'interno.todoElEquipo': 'Whole team',
    'interno.todoElHistorico': 'All time',
    'interno.meses': 'Months',
    'interno.limpiar': 'Clear filters',
    'interno.importeDesde': 'Amount from',
    'interno.importeHasta': 'Amount to',
    'interno.descargarExcel': 'Download Excel',
    'interno.horasTitulo': 'Team hours',
    'llaves.noEntra': 'Could not sign in with that key. Try your password.',
    'llaves.desafioInvalido': 'The request expired. Please try again.',
    'llaves.noVerificada': 'The key could not be checked.',
    'llaves.desconocida': 'That key is not registered.',
    'llaves.clonada': 'The key fails its security check. Remove it and create a new one.',
    'import.carteraConDatos': 'The portfolio already has properties: the initial snapshot only goes in once, and it already did.',
    'import.checkTitulo': 'Checklist templates',
    'import.checkIntro': 'Brings in the visit templates from the previous system. They are matched by name: running it again adds only the missing items.',
    'import.checkPlantillas': 'Templates',
    'import.checkItems': 'Items',
    'import.proyTitulo': 'Projects and tasks',
    'import.proyIntro': 'Brings in projects from the previous tool. Safe to run more than once: what is already there is recognised, not duplicated.',
    'import.proyEquipos': 'Teams',
    'import.proyProyectos': 'Projects',
    'import.proySecciones': 'Sections',
    'import.proyTareas': 'Tasks',
    'import.proySubtareas': 'Subtasks',
    'import.proyAsignaciones': 'Assignees set',
    'import.proyEtiquetas': 'Tags',
    'import.proyYaEstaban': 'Already there (not duplicated)',
    'import.proySinResolver': 'People in the file who are not on the team',
    'import.titulo': 'Import starting data',
    'import.intro': 'Bring in, in one go, the history the company already had: its houses, its incidents, its expenses and its team hours. Only possible on an empty portfolio, and it either all lands or none of it does.',
    'import.fichero': 'Snapshot file (.json)',
    'import.password': 'Initial password for the team',
    'import.passwordNota': 'Given to the people created here. Each one changes it on first login; management can reset it from Users.',
    'import.importar': 'Import',
    'import.importando': 'Importing…',
    'import.hecho': 'Data imported',
    'import.ficheroInvalido': 'That file is not a valid snapshot.',
    'import.deshabilitada': 'Import is not enabled on this installation.',
    'import.carteraNoVacia': 'The portfolio already has properties: importing now would duplicate them.',
    'import.usuariosCreados': 'People created',
    'import.usuariosReutilizados': 'People already there',
    'import.propiedades': 'Properties',
    'import.proveedores': 'Suppliers',
    'import.gastos': 'Expenses',
    'import.horas': 'Hours',
    'import.incidencias': 'Incidents',
    'import.eventos': 'Calendar events',
    'import.mantenimiento': 'Maintenance tasks',
    'import.estancias': 'Stays',
    'import.documentos': 'Documents',
    'import.historial': 'History entries',
    'area.INTERIOR': 'Interior',
    'area.EXTERIOR': 'Exterior',
    'area.SISTEMAS': 'Systems',
    'area.PISCINA': 'Pool',
    'area.JARDIN': 'Garden',
    'area.GESTION': 'Management',
    'area.OTRO': 'Other',
    'prov.hola': 'Hello, {nombre}',
    'prov.misEncargos': 'My jobs',
    'prov.resumen': '{total} open jobs',
    'prov.sinEncargos': 'You have no open jobs.',
    'prov.historico': 'Closed ({total})',
    'prov.instrucciones': 'Instructions',
    'prov.aceptar': 'Accept the job',
    'prov.rechazar': 'Decline',
    'prov.iniciar': 'Start work',
    'prov.solicitarFin': 'Request sign-off',
    'prov.esperandoCierre': 'Waiting to be signed off',
    'prov.presupuestar': 'Quote',
    'prov.enviarPresupuesto': 'Send quote',
    'prov.tuPresupuesto': 'Your quote',
    'prov.queIncluye': 'What it covers',
    'prov.porQue': 'Why are you declining?',
    'prov.porQueNota': 'Without a reason the team would have to call you to find out what happened.',
    'prov.motivoRechazo': 'Reason for declining',
    'encargo.ASIGNADO': 'Assigned',
    'encargo.ACEPTADO': 'Accepted',
    'encargo.EN_CURSO': 'In progress',
    'encargo.FIN_SOLICITADA': 'Sign-off requested',
    'encargo.COMPLETADO': 'Completed',
    'encargo.RECHAZADO': 'Declined',
    'encargo.sinProveedor': 'Your user is not linked to any supplier company.',
    'encargo.estadoInvalido': 'The job does not allow that action in its state.',
    'encargo.proveedorInactivo': 'That supplier is archived.',
    'encargo.encargar': 'Assign to a supplier',
    'encargo.encargos': 'Jobs',
    'proyecto.sinMiembros': 'Nobody is on this project yet.',
    'proyecto.sinCandidatos': 'Nobody left on the team to add.',
    'proyecto.responsable': 'Lead',
    'equipo.vincularPropiedad': 'Link property',
    'equipo.titulo': 'Users',
    'equipo.resumen': '{total} users in the system',
    'equipo.nuevo': 'New user',
    'equipo.crear': 'Create user',
    'equipo.buscar': 'Search by name or email...',
    'equipo.sinResultados': 'Nobody matches that search.',
    'equipo.filtroTODOS': 'All',
    'equipo.filtroEQUIPO': 'Team',
    'equipo.filtroCLIENTES': 'Clients',
    'equipo.filtroOCULTOS': 'Hidden',
    'equipo.nProp': '{total} prop.',
    'equipo.oculto': 'Hidden',
    'equipo.activo': 'Active',
    'equipo.informacion': 'Information',
    'equipo.propiedades': 'Properties',
    'equipo.nombreCompleto': 'Full name',
    'equipo.nombrePista': 'e.g. Manuel Garcia',
    'equipo.claveInicial': 'Initial password',
    'equipo.claveMinimo': 'At least 8 characters',
    'equipo.claveNueva': 'New password (min. 8)',
    'equipo.idioma': 'Language',
    'equipo.rolSistema': 'System role',
    'equipo.rolAyuda': 'Decides what data they reach. Not their trade.',
    'equipo.rolInmediato': 'The role change is immediate: they need to sign in again for it to take effect.',
    'equipo.accesoCrm': 'CRM access',
    'equipo.accesoCrmAyuda': 'The CRM shows who is being talked to, for how much and at what stage. Granted person by person.',
    'equipo.crmSi': 'With access',
    'equipo.crmNo': 'No access',
    'equipo.funcion': 'Function in the company',
    'equipo.funcionAyuda': 'What they do. It does not change what they see.',
    'equipo.guardarCambios': 'Save changes',
    'equipo.guardar': 'Save',
    'equipo.guardado': 'Saved.',
    'equipo.restablecerClave': 'Reset password',
    'equipo.claveCambiada': 'Password changed.',
    'equipo.claveCierraSesiones': 'Changing it closes all their open sessions.',
    'equipo.ocultarUsuario': 'Hide user',
    'equipo.eliminarUsuario': 'Delete user',
    'equipo.reactivar': 'Reactivate user',
    'equipo.tieneHistoricoNota': 'This person already logged work, so they are not deleted: they are hidden and their history is kept.',
    'equipo.sinHistoricoNota': 'They never logged any work, so they can be deleted without orphaning anything.',
    'equipo.sinPropiedades': 'No properties assigned.',
    'equipo.asignarPropiedad': 'Assign property',
    'equipo.buscarPropiedad': 'Search by name or code...',
    'equipo.sinCandidatas': 'No properties left to assign.',
    'equipo.rolEnPropiedad': 'Role on the property',
    'equipo.retirar': 'Remove',
    'equipo.emailDuplicado': 'That email is already in use.',
    'equipo.ultimoDirector': 'The company would be left without management.',
    'equipo.noATiMismo': 'You cannot do that to yourself.',
    'equipo.tieneHistorico': 'That person already logged work: they are hidden, not deleted.',
    'equipo.clienteVaPorParty': 'An owner is linked to a property from their person record, because that link is what billing rests on.',
    'equipo.inactivo': 'That person is deactivated.',
    'asignacion.PRINCIPAL': 'Primary',
    'asignacion.SECUNDARIO': 'Secondary',
    'asignacion.OWNER': 'Owner',
    'asignacion.PROMOTER': 'Developer',
    'asignacion.ASSET_MANAGER': 'Asset manager',
    'asignacion.AUTHORIZED_CONTACT': 'Authorised contact',
    'funcion.DIRECCION': 'Management',
    'funcion.MANAGER': 'Manager',
    'funcion.MARKETING': 'Marketing',
    'funcion.REAL_ESTATE': 'Real Estate',
    'funcion.MANTENIMIENTO': 'Maintenance',
    'funcion.JARDINERIA': 'Gardening',
    'funcion.LIMPIEZA': 'Cleaning',
    'funcion.ADMINISTRACION': 'Administration',
    'funcion.OTRA': 'Other',
    'proyecto.soloEquipo': 'Only team members join an internal project.',
    'proyecto.miembros': 'Members',
    'proyecto.anadirMiembro': 'Add to project',
    'contacto.intro': 'How to reach us, and the questions that come up most.',
    'contacto.comoEscribir': 'How to write to us',
    'contacto.reportarPie': 'From your portal. We see it the same day and tell you the urgency.',
    'contacto.responderHilo': 'Reply inside the incident',
    'contacto.responderHiloPie': 'Open any incident and write: the message reaches whoever handles it.',
    'contacto.faq': 'Frequently asked questions',
    'contacto.p.semaforo': "What does my property's status mean?",
    'contacto.r.semaforo': 'Green means everything is up to date. Amber means something is open but not urgent. Red means something needs attention now, and in that case we are already on it.',
    'contacto.p.idiomaClave': 'How do I change the language or my password?',
    'contacto.r.idiomaClave': 'The language is changed at the bottom left, at any time. The password is changed from Settings.',
    'contacto.p.reportar': 'How do I report something?',
    'contacto.r.reportar': 'With the report button in your portal. Describe what you see in your own words: we set the technical urgency when we review it.',
    'contacto.p.informe': 'Where can I see what has been done at my house?',
    'contacto.r.informe': 'Under My incidents you have every intervention with its photos and its conversation. What appears there is what the team has shared with you.',
    'cartera.resumenAsignadas': '{total} assigned · {atencion} need attention',
    'panel.miPanel': 'My Panel',
    'portal.buenosDias': 'Good morning, {nombre}',
    'portal.buenasTardes': 'Good afternoon, {nombre}',
    'portal.buenasNoches': 'Good evening, {nombre}',
    'portal.tusPropiedades': 'Your properties',
    'portal.misPropiedades': 'My properties',
    'portal.sinPropiedades': 'You have no properties assigned yet.',
    'portal.visitasAnio': 'Visits this year',
    'portal.incidenciasAbiertas': 'Open incidents',
    'portal.enCurso': 'in progress',
    'portal.alCorriente': 'Up to date on payments',
    'portal.proximaVisita': 'Your next visit: {fecha}',
    'portal.misIncidencias': 'My incidents',
    'portal.sinIncidencias': 'Nothing is open right now.',
    'portal.filtroABIERTAS': 'Open',
    'portal.filtroRESUELTAS': 'Resolved',
    'portal.filtroTODAS': 'All',
    'portal.sinEnEsteFiltro': 'Nothing here.',
    'portal.abierta': 'Open',
    'portal.resuelta': 'Resolved',
    'portal.resumen': 'Summary of your property',
    'portal.resumenPie': 'Written automatically from the data you can see on this page.',
    'portal.resumenNoDisponible': 'The automatic summary is not available right now.',
    'portal.fotos': 'Photos',
    'portal.mensajes': 'Messages',
    'portal.sinMensajes': 'No messages yet. Write if you have any questions.',
    'portal.escribeMensaje': 'Write a message...',
    'portal.enviar': 'Send',
    'portal.tuEstancia': 'Your stay',
    'portal.sinEstancias': 'No stay has been notified.',
    'portal.avisarLlegada': 'Notify my arrival',
    'portal.llegada': 'Arrival',
    'portal.salida': 'Departure (optional)',
    'portal.estanciaNota': 'This keeps us from scheduling a visit while you are at the house.',
    'portal.reportar': 'Report an incident',
    'portal.queOcurre': 'What is happening?',
    'portal.queOcurrePista': 'For example: the kitchen tap is dripping',
    'portal.detalles': 'Details (optional)',
    'portal.reportarNota': 'We review it and tell you the urgency and next steps.',
    'portal.facturacion': 'Billing details',
    'portal.documentos': 'Your property documents',
    'portal.sinDocumentos': 'No documents shared yet.',
    'ficha.verDueno': 'Owner can see it',
    'portal.facturacionPie': 'Add your details so they appear on your invoice.',
    'portal.facturacionCampo': 'Legal name, tax ID and address',
    'portal.facturacionPista': 'Name or company\nTax ID\nFull address',
    'portal.editar': 'Edit',
    'portal.guardar': 'Save',
    'portal.contacto': 'Contact',
    'portal.ajustes': 'Settings',
    'rapido.fecha': 'Date',
    'rapido.importe': 'Amount',
    'rapido.queEs': 'What',
    'rapido.titulo': 'What do you want to log?',
    'rapido.gasto': 'An expense',
    'rapido.horas': 'Work hours',
    'rapido.horasPie': 'Time spent',
    'rapido.comprobante': 'Receipt',
    'rapido.fotoObligatoria': 'A photo of the receipt or invoice is required: without it the expense cannot be justified.',
    'rapido.hacerFoto': 'Take a photo or pick a file',
    'rapido.formatosFoto': 'Image or PDF',
    'rapido.deQuienSon': 'Whose work is it?',
    'rapido.deQuienSonPie': 'Management can log work for people who do not use the app.',
    'rapido.mias': 'Mine',
    'rapido.paraQuien': 'Who is it for?',
    'rapido.cliente': "A client's",
    'rapido.clientePie': 'Goes to a property',
    'rapido.interno': 'Internal',
    'rapido.internoPie': 'Company, no property',
    'rapido.queCliente': 'Which property?',
    'rapido.vinculado': 'Does it relate to an open issue?',
    'rapido.aislado': 'No issue',
    'error.gastoDeHoras': 'This line comes from logged hours: its hours and rates are corrected from “Edit” with the hours; here only the description changes.',
    'categoriaGasto.MANO_DE_OBRA': 'Labour',
    'rapido.otraPersona': 'Other: type a name',
    'rapido.otraPersonaPie': 'A supplier or someone not using the app',
    'rapido.nombrePersona': 'Name of the person or supplier',
    'rapido.vinculadoPie': 'Tick one or several, add a description, or both.',
    'rapido.descripcionManual': 'Manual description',
    'rapido.descripcionManualPie': 'Write what was done',
    'rapido.queSeHizo': 'What was done?',
    'rapido.continuar': 'Continue',
    'rapido.costeYPrecio': 'Hourly cost and price',
    'rapido.costeYPrecioPie': 'Taken from the team rates. You can change it for this job only.',
    'rapido.costeHora': 'Hourly cost (€)',
    'rapido.precioHora': 'Hourly price for the client (€)',
    'rapido.facturableExtra': 'Billable as extra?',
    'rapido.extraSi': 'Shows in the property expenses and is charged to the client',
    'rapido.extraNo': 'Internal cost: included in the fee, the client sees €0',
    'rapido.costeHoraInvalido': 'Enter the hourly cost (it can be 0).',
    'rapido.precioHoraInvalido': 'To charge it separately, enter the hourly price for the client.',
    'gastos.descripcion': 'Description',
    'gastos.descripcionPlaceholder': 'What was done…',
    'gastos.incidencias': 'Related issues',
    'gastos.sinIncidenciasAbiertas': 'This property has no open issues.',
    'gastos.incluidoEnFee': 'Included in fee',
    'ficha.precioParaCliente': 'Price for the client',
    'ficha.editarTarifa': 'Edit rate',
    'ficha.tarifaPrecioPie': 'Click an amount to change it. EUR/hour and client price are suggested when logging hours on this property.',
    'finreg.precioCliente': 'Client price/hour',
    'rapido.queTrabajo': 'What kind of work?',
    'rapido.queTrabajoPie': 'This decides how the hours are classified.',
    'rapido.queCategoria': 'What kind of expense?',
    'rapido.cuantasHoras': 'How long?',
    'rapido.cuanto': 'How much?',
    'rapido.tiempoManual': 'Or type the time',
    'rapido.tiempoManualPie': 'Accepts 45 · 1.5 · 1:45 (hours:minutes)',
    'rapido.tiempoInvalido': 'That time is not understood. Try 45, 1.5 or 1:45 (up to 744 h).',
    'rapido.tiempoEjemplo': '1.45',
    'rapido.importeManual': 'Or type the amount',
    'rapido.repercutible': 'Is it charged to the client?',
    'rapido.repercutiblePie': "If charged, it goes into the property's next invoice.",
    'rapido.entraEnFactura': 'Goes into their invoice',
    'rapido.loAsumimos': 'We absorb it',
    'rapido.si': 'Yes',
    'rapido.no': 'No',
    'rapido.cuando': 'Which day?',
    'rapido.hoy': 'Today',
    'rapido.ayer': 'Yesterday',
    'rapido.fechaInvalida': 'Enter the full date (day, month and year). It cannot be in the future or before 2000.',
    'rapido.otraFecha': 'Another date',
    'rapido.revisar': 'Check before sending',
    'rapido.notaOpcional': 'Note (optional)',
    'rapido.enviar': 'Send',
    'rapido.enviado': 'Logged.',
    'rapido.otroMas': 'Log another',
    'rapido.verCargado': 'Back',
    'rapido.atras': 'Back',
    'rapido.confirmar': 'Confirm',
    'rapido.toques': 'Step {n} of {total}',
    'nav.registrar': 'Log',
    'inc.fotoOcultaAyuda': 'Only the team can see it. Tap to share it with the owner.',
    'inc.fotoVisibleAyuda': 'The owner can see it. Tap to stop sharing it.',
    'factura.titulo': 'Invoices',
    'factura.crear': 'Invoice pending',
    'factura.sinFacturas': 'No invoices yet.',
    'factura.emitir': 'Issue',
    'factura.cobrar': 'Mark paid',
    'factura.vencidaDias': '{total}d overdue',
    'factura.estadoBORRADOR': 'Draft',
    'factura.estadoEMITIDA': 'Issued',
    'factura.estadoCOBRADA': 'Paid',
    'factura.estadoANULADA': 'Voided',
    'factura.sinPendiente': 'No rechargeable expenses pending invoicing.',
    'factura.estadoInvalido': 'The invoice does not allow that action in its state.',
    'anomalia.titulo': 'Spend anomalies',
    'anomalia.total': '{total} anomalies',
    'anomalia.metodo': 'Detected with median and absolute deviation: one very large expense cannot mask itself.',
    'severidad.ALTA': 'High',
    'severidad.MEDIA': 'Medium',
    'severidad.BAJA': 'Low',
    'visita.empezarLista': 'Start the checklist',
    'visita.continuarLista': 'Continue the checklist',
    'visita.verLista': 'View the checklist',
    'visita.desdeAgenda': 'From the calendar: {titulo}',
    'visita.deLaAgenda': 'From the calendar',
    'visita.iniciar': 'Start visit',
    'visita.plantilla': 'From template',
    'visita.editar': 'Edit the visit',
    'visita.anadirNota': 'Add a note',
    'visita.motivo': 'What the visit is for',
    'visita.descartar': 'Leave and discard',
    'visita.confirmarDescartar': 'Leave without closing the visit? You lose what you have marked and the visit counts as not done.',
    'visita.enCursoAviso': 'You have a visit under way. Open it to finish or discard it.',
    'visita.realizadas': 'Visits carried out',
    'visita.programadas': 'Scheduled visits',
    'visita.continuarVisita': 'Continue the visit',
    'visita.verVisita': 'See the visit',
    'visita.motivoOpcional': 'What the visit is for (optional)',
    'visita.motivoPie': 'Why you are going: what to check, what the client asked for',
    'visita.porMotivo': 'No list · for a specific reason',
    'visita.detalle': 'Detail (optional)',
    'visita.notaPie': 'What you found, what you did',
    'visita.notaVisita': 'Visit note',
    'visita.quitarFoto': 'Remove the photo',
    'visita.confirmarQuitarFoto': 'Remove this photo? This cannot be undone.',
    'visita.elegirPlantilla': 'Choose a checklist…',
    'visita.resumenPlegado': '{hechos} of {total} points · {fotos} photos',
    'visita.plegar': '← Close this visit',
    'evento.sinTitulo': 'Choose a checklist for the visit.',
    'visita.sinPlantilla': 'No template (free visit)',
    'visita.copiaNota': 'Items are copied on start: editing the template later does not change this visit.',
    'visita.sinItems': 'This visit has no checklist.',
    'visita.pendientes': '{total} unmarked',
    'visita.completar': 'Complete visit',
    'visita.abrira': 'will open {total} issues',
    'visita.completadaCon': 'Visit completed. {total} issues were opened.',
    'visita.completadaSin': 'Visit completed with no issues.',
    'visita.estadoEN_CURSO': 'In progress',
    'visita.estadoCOMPLETADA': 'Completed',
    'visita.estadoABANDONADA': 'Abandoned',
    'visita.resOK': 'OK',
    'visita.resINCIDENCIA': 'Issue',
    'visita.resNO_APLICA': 'N/A',
    'visita.resPENDIENTE': 'Pending',
    'visita.estadoInvalido': 'The visit is already closed.',
    'panel.facturasPorCobrar': 'Invoices to collect',
    'panel.emitidaEl': 'Issued on {fecha}',
    'panel.rendimientoEquipo': 'Team performance',
    'panel.cumplimientoNota': 'Visits completed against those scheduled this month.',
    'panel.agendadas': 'Scheduled',
    'panel.completadas': 'Completed',
    'panel.cumplimiento': 'Completion',
    'panel.sinAgenda': 'no schedule',
    'panel.informeCartera': 'Monthly report',
    'mio.horas': 'Hours this month',
    'mio.horasPie': 'across {total} time entries',
    'mio.gastos': 'Expenses this month',
    'mio.gastosPie': '{total} recorded',
    'mio.aCobrar': 'Due to you so far',
    'mio.aCobrarPie': 'for the hours recorded, at each property’s rate',
    'mio.incidencias': 'Issues in my properties',
    'mio.incidenciasPie': '{n1} urgent · {n2} priority',
    'mio.ocupacion': 'Occupied properties',
    'mio.ocupacionPie': 'of the ones I manage',
    'mio.proximasVisitas': 'Upcoming visits',
    'mio.sinVisitas': 'No visits scheduled.',
    'mio.informe': 'My monthly report',
    'mio.informeNota': 'Your hours, your visits, the issues you resolved and the pay calculation.',
    'panel.hola': 'Hello, {nombre}',
    'panel.margenMes': 'Margin this month',
    'panel.margenPie': 'billable minus cost',
    'panel.costeSoportado': 'Cost carried',
    'panel.costePie': 'advanced by the manager',
    'panel.facturable': 'Billable to clients',
    'panel.facturablePie': 'cost plus margin',
    'panel.gastoInterno': 'Internal spend',
    'panel.gastoInternoPie': 'organisation, this month',
    'panel.clientes': 'Clients',
    'panel.incidenciasCriticas': 'Critical issues',
    'panel.deAbiertas': 'of {total} open',
    'panel.horasMes': 'Hours this month',
    'panel.horasPie': 'logged against properties',
    'panel.pendienteFacturar': 'Pending invoicing',
    'panel.pendienteFacturarNota': 'Approved, rechargeable work not yet invoiced.',
    'panel.nGastos': '{total} expenses',
    'panel.esperando': 'waiting {total}d',
    'panel.incidenciasActivas': 'Open issues',
    'panel.total': '{total} total',
    'panel.criticasAbiertas': 'Open critical issues',
    'panel.resumenPropiedades': 'Property overview',
    'panel.propiedad': 'Property',
    'panel.ocupacion': 'Property occupancy',
    'panel.ocupadasAhora': 'Occupied now ({total})',
    'panel.ningunaOcupada': 'None occupied right now.',
    'panel.proximasLlegadas': 'Upcoming arrivals ({total})',
    'panel.noches': '{total} nights',
    'panel.proximasVisitas': 'Upcoming scheduled visits',
    'panel.cargaOperativa': 'Workload by person',
    'panel.horasPorTrabajador': 'Hours by person',
    'panel.actividadReciente': 'Recent activity',
    'mant.nueva': 'New maintenance task',
    'mant.titulo': 'Title',
    'mant.area': 'Area',
    'mant.frecuencia': 'Frequency',
    'mant.antelacion': 'Lead days',
    'mant.fechaInicio': 'Start date',
    'mant.comoVisita': 'As a visit',
    'mant.comoIncidencia': 'As an issue',
    'mant.proveedorOpcional': 'Provider (optional)',
    'mant.guardar': 'Save task',
    'prov.nuevo': 'New provider',
    'prov.empresa': 'Company',
    'prov.categoria': 'Category',
    'prov.contacto': 'Contact',
    'prov.productos': 'Products / warranties and notes',
    'prov.productosPista': 'e.g. Vaillant boiler, warranty until 2028',
    'gasto.registrar': 'Record expense',
    'gasto.importe': 'Amount (EUR)',
    'gasto.fecha': 'Expense date',
    'gasto.margen': 'Profit margin (%)',
    'gasto.sinProveedor': 'No provider',
    'gasto.nombreLibre': 'Free-text name',
    'gasto.nombreLibrePista': 'e.g. Leroy Merlin',
    'gasto.conceptoPista': 'e.g. Plumbing materials',
    'gasto.facturable': 'Billable to client',
    'gasto.visiblePortal': 'Visible in client portal',
    'gasto.ticket': 'Receipt / invoice photo',
    'gasto.registrarBoton': 'Record',
    'gasto.anadir': 'Add',
    'doc.fichero': 'File',
    'doc.tipos': 'PDF, Word, Excel or image. Max 20 MB.',
    'visita.programar': 'Schedule visit',
    'avisos.titulo': 'Notifications',
    'avisos.vacio': 'Nothing pending. All clear.',
    'avisos.marcarTodas': 'Mark all read',
    'avisoTipo.INCIDENCIA_CRITICA': 'Critical issue',
    'avisoTipo.VISITA_VENCIDA': 'Overdue visit',
    'avisoTipo.MANTENIMIENTO_VENCIDO': 'Overdue maintenance',
    'avisoTipo.GASTO_PENDIENTE': 'Expense awaiting approval',
    'avisoTipo.PAGO_RECURRENTE': 'Recurring payment',
    'avisoTipo.FACTURA_VENCIDA': 'Overdue invoice',
    'avisoTipo.OTRO': 'Notice',
    'verComo.etiqueta': 'View as',
    'verComo.aviso': 'You are viewing the app as {rol}.',
    'verComo.volver': 'Back to {rol}',
    'inc.proveedor': 'Provider',
    'inc.sinAsignar': 'Unassigned',
    'inc.elegirProveedor': 'Choose provider...',
    'inc.quitar': 'Remove',
    'inc.presupuestos': 'Quotes received',
    'inc.solicitar': 'Request',
    'inc.sinPresupuestos': 'No quotes yet.',
    'inc.guardarPresupuesto': 'Save quote',
    'inc.estado': 'Status',
    'inc.pedirMotivo': 'Why is it being cancelled? This is recorded on the incident.',
    'inc.pedirResolucion': 'How was it resolved? This is recorded on the incident.',
    'inc.urgencia': 'Urgency',
    'inc.costeEstimado': 'Estimated cost',
    'inc.costeFinal': 'Final cost',
    'inc.fotos': 'Evidence photos',
    'inc.anadirFoto': 'Add photo',
    'inc.sinFotos': 'No photos or documents.',
    'inc.chatInterno': 'Internal chat',
    'inc.chatInternoNota': 'No comments yet. Be the first to write.',
    'inc.mensajesCliente': 'Client messages',
    'inc.mensajesClienteNota': 'No messages yet. The client can also write here.',
    'inc.visibleAlCliente': 'Visible to client',
    'inc.enviar': 'Send',
    'inc.fechaEsperada': 'Expected resolution date',
    'inc.fechaEsperadaNota': 'The date the team commits to. It shows up in «Today» on the day, and in red once it passes. This is not the SLA.',
    'inc.visibilidad': 'Portal visibility',
    'inc.visiblePropietario': 'Visible to owner',
    'inc.ocultaPropietario': 'Hidden from owner',
    'inc.visibilidadNota': 'The owner only sees issues marked as visible.',
    'inc.creada': 'Created',
    'inc.cerrada': 'Closed',
    'adjunto.tipoNoAdmitido': 'That file type is not accepted.',
    'adjunto.demasiadoGrande': 'The file exceeds the maximum size (20 MB).',
    'adjunto.vacio': 'The file is empty.',
    'adjunto.rutaInvalida': 'Invalid file path.',
    'ficha.filtroABIERTAS': 'Open',
    'ficha.filtroCERRADAS': 'Closed',
    'ficha.filtroTODAS': 'All',
    'ficha.nivel': 'Level',
    'ficha.todos': 'All',
    'ficha.sinIncidencias': 'No issues match this filter.',
    'ficha.slaIncumplido': 'SLA breach',
    'ficha.estimado': 'est.',
    'ficha.final': 'final',
    'ficha.precioCliente': 'Client price',
    'ficha.gastado': 'Spent',
    'ficha.porCobrar': 'To collect',
    'ficha.porCobrarAyuda': 'What is recharged to the client, approved, marked “To collect” and not yet invoiced. Same figure as the Dashboard.',
    'ficha.noRepercutido': '{importe} not recharged ({total})',
    'ficha.noRepercutidoAyuda': 'Property expenses not marked as recharged to the client. They do not count towards what is collected.',
    'ficha.repercutir': 'Recharge to client',
    'ficha.repercutirAyuda': 'This expense is not charged to the client. Click to move it to “To collect”.',
    'ficha.noSeRepercute': 'Not recharged',
    'ficha.confirmarRepercutir': 'Recharge “{concepto}” to the client? It will move to “To collect” and be visible in their portal.',
    'ficha.alCliente': 'to client',
    'ficha.sinFichero': 'no file',
    'ficha.documentos': 'Agreements and documents',
    'ficha.sinDocumentos': 'No documents.',
    'ficha.subirDocumento': 'Upload document',
    'ficha.tituloDocumento': 'Document title',
    'ficha.urlDocumento': 'File address',
    'ficha.abrir': 'Open',
    // --- AI and analytics -----------------------------------------------------
    'ia.anio': 'Year',
    'ia.mes': 'Month',
    'ia.resumenesTitulo': 'Client portal summaries',
    'ia.resumenesIntro': 'Generated over a closed month, reviewed and published. The owner reads what the company decided to tell them, not what a model improvised while the page loaded.',
    'ia.eligePropiedad': 'Choose a property',
    'ia.idiomaResumen': 'Summary language',
    'ia.generar': 'Generate',
    'ia.generando': 'Generating…',
    'ia.sinResumenes': 'No summaries for this month yet.',
    'ia.estado.BORRADOR': 'Draft',
    'ia.estado.PUBLICADO': 'Published',
    'ia.editar': 'Edit',
    'ia.guardar': 'Save',
    'ia.publicar': 'Publish to client',
    'ia.retirar': 'Unpublish',
    'ia.escritoAMano': 'edited by hand',
    'ia.conectada': 'Connected',
    'ia.sinProveedor': 'No provider',
    'ia.sinProveedorNota': 'No AI provider is configured, so no summary can be generated. Without AI we do not hand over a template dressed up as one.',
    'ia.informesTitulo': 'Activity reports',
    'ia.informesIntro': 'For the selected month, as PDF. Each report carries that person’s hours, visits, issues resolved and pay calculation.',
    'ia.informeCartera': 'Whole portfolio',
    'ia.informeCarteraNota': 'Every property for the month',
    'ia.descargar': 'Download',
    'ia.conexionTitulo': 'AI connection',
    'ia.pruebaOk': 'The connection works.',
    'ia.pruebaFallo': 'The connection failed.',
    'ia.noConfigurada': 'AI is not configured: the summary cannot be generated.',
    'mes.enero': 'January',
    'mes.febrero': 'February',
    'mes.marzo': 'March',
    'mes.abril': 'April',
    'mes.mayo': 'May',
    'mes.junio': 'June',
    'mes.julio': 'July',
    'mes.agosto': 'August',
    'mes.septiembre': 'September',
    'mes.octubre': 'October',
    'mes.noviembre': 'November',
    'mes.diciembre': 'December',
    'ia.titulo': 'AI and reports',
    'ia.sub': 'The monthly summary the owner reads, and the activity reports.',
    'ia.conexion': 'AI connection',
    'ia.probar': 'Test connection',
    'ia.probando': 'Testing…',
    'ia.conexionPie': 'Makes a real, minimal call to the provider. It costs a few cents, which is why it does not run on its own when this screen opens. It is the connection the client portal summary uses, which today is the only place where AI writes anything.',
    'ia.noSeProbo': 'The connection could not be tested.',
    'ia.anomalias': 'Unusual spend (last {meses} months)',
    'ia.analizando': 'Analysing…',
    'ia.sinAnomalias': 'No anomalies found. Spend is checked against its own history.',
    'ia.noSeCargaron': 'The anomalies could not be loaded.',
    'ia.severidad': 'Severity',
    'ia.tipo': 'Type',
    'ia.concepto': 'Item',
    'ia.propiedad': 'Property',
    'ia.importe': 'Amount',
    'ia.motivo': 'Reason',
    'ia.tipoOUTLIER': 'Unusual amount',
    'ia.tipoDUPLICADO': 'Possible duplicate',
    'ia.sevALTA': 'High',
    'ia.sevMEDIA': 'Medium',
    'ia.sevBAJA': 'Low',
    'ia.clasificar': 'Classify an incident',
    'ia.clasificarPie': 'Describe the incident and it suggests a level and a category (it does not decide: it only points). The suggestion comes from a keyword heuristic, not from AI.',
    'ia.clasificarEjemplo': 'E.g.: There is a water leak under the kitchen sink',
    'ia.clasificarBoton': 'Classify',
    'ia.noSeClasifico': 'It could not be classified.',
    'ia.nivelSugerido': 'Level {nivel}',
    'ia.porIa': 'by AI',
    'ia.porHeuristica': 'heuristic',
    'iaCat.SEGURIDAD': 'Safety',
    'iaCat.FONTANERIA': 'Plumbing',
    'iaCat.ELECTRICIDAD': 'Electrics',
    'iaCat.CLIMATIZACION': 'Heating and cooling',
    'iaCat.CERRAJERIA': 'Locks and glazing',
    'iaCat.EXTERIORES': 'Grounds',
    'iaCat.MANTENIMIENTO': 'Upkeep',
    'iaCat.GENERAL': 'General',
    'dia.titulo': "Today's tasks",
    'dia.nadaPendiente': 'Nothing pending',
    'dia.pendientes': '{total} pending',
    'dia.vacio': 'You have no tasks due today and no visits scheduled. Tasks with no due date do not appear here.',
    'dia.incidencias': 'Issues to handle',
    'dia.visitas': 'Scheduled visits',
    'dia.deProyectos': 'From projects',
    'dia.sinPropiedad': 'No property',
    'dia.ver': 'View',
    'dia.hoy': 'Today',
    'dia.atrasada': 'Overdue',
    'dia.completarTarea': 'Complete {titulo}',
    'dia.noSeCargo': 'The day could not be loaded.',
    'dia.noSeCompleto': 'The task could not be completed.',
    'fin.tarifasGenerales': 'General team rates',
    'fin.tarifasGeneralesPie': 'What each person earns when a property has no rate of its own, and what internal hours are paid at. Click an amount to change it.',
    'fin.titulo': 'Finance',
    'fin.sub': 'Monthly summary: hours and costs turned into what gets invoiced.',
    'fin.registrar': '+ Log hours/costs',
    'fin.ocultarRegistro': 'Hide the form',
    'fin.mes': 'Month',
    'fin.anio': 'Year',
    'fin.noSeCargo': 'The summary could not be loaded.',
    'fin.base': 'Net',
    'fin.iva': 'VAT',
    'fin.total': 'Total',
    'fin.vacio': 'No hours or costs recorded in {mes} {anio}.',
    'fin.colTipo': 'Type',
    'fin.colConcepto': 'Item',
    'fin.colPropiedad': 'Property',
    'fin.colPersona': 'Person',
    'fin.colBase': 'Net',
    'fin.colTotal': 'Total',
    'fin.colFacturacion': 'Invoicing',
    'fin.tipoHORAS_FIJAS': 'Fixed fee',
    'fin.tipoHORAS': 'Hours',
    'fin.tipoGASTO': 'Cost',
    'fin.modoFACTURA_CON_IVA': 'Invoice with VAT',
    'fin.modoPRESUPUESTO_SIN_IVA': 'Quote',
    'fin.modoHOLDED': 'Holded',
    'ref.titulo': 'Referrals',
    'ref.sub': 'Who brings you business, and what they earn.',
    'ref.nuevo': 'New referral',
    'ref.nombrePlaceholder': 'Name of the referral',
    'ref.comision': 'Commission',
    'ref.porcentaje': 'Percentage',
    'ref.fija': 'Fixed',
    'ref.porcentajeCampo': 'Percentage (%)',
    'ref.importeCampo': 'Amount (€)',
    'ref.anadir': '+ Add',
    'ref.filtroTODOS': 'All',
    'ref.filtroPENDIENTE': 'Pending',
    'ref.filtroCONVERTIDO': 'Converted',
    'ref.filtroDESCARTADO': 'Dropped',
    'ref.vacio': 'No referrals in this state.',
    'ref.colReferido': 'Referral',
    'ref.colQuienRefiere': 'Referred by',
    'ref.colEstado': 'State',
    'ref.colAcciones': 'Actions',
    'ref.estadoPENDIENTE': 'Pending',
    'ref.estadoCONVERTIDO': 'Converted',
    'ref.estadoDESCARTADO': 'Dropped',
    'ref.basePlaceholder': 'base €',
    'ref.baseDe': 'Base for {nombre}',
    'ref.convertir': 'Convert',
    'ref.descartar': 'Drop',
    'ref.motivoDescarte': 'Dropped from the panel',
    'ref.noSeCargaron': 'The referrals could not be loaded.',
    'ref.noSeCreo': 'The referral could not be created.',
    'ref.noSeConvirtio': 'It could not be converted.',
    'ref.noSeDescarto': 'It could not be dropped.',
    'import.crmTitulo': 'Opportunities from the previous CRM',
    'import.crmIntro': 'Brings in the sales pipeline from the previous CRM. Safe to repeat: each opportunity carries the id it had in its source, so a second run updates instead of duplicating.',
    'import.crmOportunidades': 'opportunities',
    'import.crmCreadas': 'Created',
    'import.crmActualizadas': 'Updated',
    'import.crmTotal': 'Total',
    'import.crmSuma': 'Total value',
    'import.crmNotas': 'New notes',
    'import.crmTareas': 'New tasks',
    'import.crmFusionadas': 'Recognised by name ({n}):',
    'import.crmPorEmbudo': 'By pipeline',
    'import.crmEmbudosCreados': 'Pipelines created',
    'import.crmEtapasCreadas': 'Stages created',
    'import.crmResponsables': 'Owners matched',
    'import.embudoDesconocido': 'That pipeline does not exist in the app. Create it before importing.',
    'import.etapaDesconocida': 'A stage in the file does not exist in its pipeline. Nothing was imported.',
    'import.exclusivoDesconocido': 'An opportunity in the file is exclusive to someone who is not a user of the company. Nothing was imported.',
    'import.externalIdRepetido': 'The file contains the same opportunity twice.',
    'import.totalNoCuadra': 'The count does not match what was expected. Nothing was imported.',
    'import.sumaNoCuadra': 'The total value does not match what was expected. Nothing was imported.',
    'crm.embudo': 'Pipeline',
    'crm.origen': 'Source',
    'crm.etiquetas': 'Tags',
    'crm.contacto': 'Contact',
    'crm.responsableOriginal': 'Owner in the previous CRM',
    'crm.datosExternos': 'Inherited qualification',
    'crm.importada': 'Imported',
    'crm.sub': 'Run your sales through pipelines.',
    'crm.nuevaOportunidad': 'New opportunity',
    'crm.nombrePlaceholder': 'Name (e.g. Clifftop villa)',
    'crm.valor': 'Value (€, optional)',
    'crm.anadir': '+ Add',
    'crm.ganada': 'Won',
    'crm.perdida': 'Lost',
    'crm.mover': 'Move {nombre}',
    'crm.noSeCargaronEmbudos': 'The pipelines could not be loaded.',
    'crm.noSeCargaronOportunidades': 'The opportunities could not be loaded.',
    'crm.faltaNombre': 'Type a name for the opportunity.',
    'crm.noSeCreo': 'The opportunity could not be created.',
    'crm.noSeMovio': 'The opportunity could not be moved.',
    'crm.ficha.info': 'Contact and opportunity',
    'crm.ficha.propiedad': 'Property details',
    'crm.ficha.tareas': 'Tasks',
    'crm.ficha.notas': 'Notes',
    'crm.ficha.contacto': 'Contact details',
    'crm.ficha.oportunidad': 'Opportunity details',
    'crm.ficha.ocultarVacios': 'Hide empty fields',
    'crm.ficha.contactoNombre': 'Main contact name',
    'crm.ficha.email': 'Email',
    'crm.ficha.telefono': 'Phone',
    'crm.ficha.llamar': 'Call',
    'crm.ficha.adicionales': 'Additional contacts (max. 10)',
    'crm.ficha.anadirContacto': 'Add contact',
    'crm.ficha.rol': 'Role',
    'crm.ficha.nombre': 'Opportunity name',
    'crm.ficha.embudo': 'Pipeline',
    'crm.ficha.etapa': 'Stage',
    'crm.ficha.estado': 'Status',
    'crm.estado.ABIERTA': 'Open',
    'crm.estado.GANADA': 'Won',
    'crm.estado.PERDIDA': 'Lost',
    'crm.ficha.valor': 'Value (€)',
    'crm.ficha.motivoPerdida': 'Reason for losing it',
    'crm.ficha.propietario': 'Owner',
    'crm.ficha.sinAsignar': 'Unassigned',
    'crm.ficha.seguidores': 'Followers',
    'crm.ficha.anadirSeguidor': 'Add follower',
    'crm.ficha.quitar': 'Remove',
    'crm.ficha.empresa': 'Company name',
    'crm.ficha.fuente': 'Source',
    'crm.ficha.cierrePrevisto': 'Expected close date',
    'crm.ficha.etiquetas': 'Tags',
    'crm.ficha.anadirEtiqueta': 'Add tag',
    'crm.ficha.encaje': 'Cultural fit',
    'crm.ficha.idioma': 'Language',
    'crm.ficha.usoReal': 'Actual use of the property',
    'crm.ficha.riesgos': 'Risks detected',
    'crm.ficha.zona': 'Area',
    'crm.ficha.superficie': 'Approximate size',
    'crm.ficha.tipoPropiedad': 'Property type',
    'crm.ficha.vistas': 'Views',
    'crm.ficha.m2Solar': 'Min. plot m²',
    'crm.ficha.m2Habitables': 'Min. living m²',
    'crm.ficha.dormitorios': 'Bedrooms',
    'crm.ficha.banos': 'Bathrooms',
    'crm.ficha.propuestoMax': 'Max. proposed €',
    'crm.ficha.estaEnLaIsla': 'On the island',
    'crm.ficha.viveEnLaIsla': 'Lives on the island',
    'crm.ficha.creadoPor': 'Created by: {nombre}',
    'crm.ficha.creadoEl': 'Created on {fecha}',
    'crm.ficha.guardado': 'Saved.',
    'crm.ficha.descartarCambios': 'There are unsaved changes. Close anyway?',
    'crm.ficha.anadirTarea': 'Add task',
    'crm.ficha.tituloTarea': 'What needs doing',
    'crm.ficha.vence': 'Due date',
    'crm.ficha.responsableTarea': 'Who does it',
    'crm.ficha.detalleTarea': 'Details (optional)',
    'crm.ficha.tareaEnPanel': 'It will appear in the day panel of whoever does it.',
    'crm.ficha.buscarTarea': 'Search by title',
    'crm.ficha.sinTareas': 'No tasks yet.',
    'crm.ficha.sinFechaNiResponsable': 'No date or owner',
    'crm.ficha.buscarNotas': 'Search notes',
    'dia.crm': 'From opportunities',
    'crm.exclusiva': 'Exclusive to {nombre}',
    'crm.error.exclusivoSinCrm': 'That person has no access to the CRM, so they cannot handle an opportunity exclusively.',
    'crm.asistente.titulo': 'Assistant',
    'crm.asistente.abrir': 'Assistant',
    'crm.asistente.intro': 'Tell me what happened with a client, the way you would tell a colleague, or paste a screenshot of the conversation. I can also add a new client. I will suggest the changes — the note, the column, the next step — and you decide what gets applied.',
    'crm.asistente.placeholder': 'E.g.: Spoke with Pouline, she is reviewing our offer',
    'crm.asistente.enviar': 'Send',
    'crm.asistente.adjuntar': 'Attach screenshot',
    'crm.asistente.dictar': 'Dictate',
    'crm.asistente.pararDictado': 'Stop dictating',
    'crm.asistente.escuchando': 'Listening… speak normally and tap the microphone to finish. Check it before sending.',
    'crm.asistente.dictado.noSoportado': 'This browser cannot dictate. On a phone, use the keyboard microphone.',
    'crm.asistente.dictado.permiso': 'To dictate, allow microphone access in your browser.',
    'crm.asistente.dictado.sinVoz': 'I did not hear you. Tap the microphone and try again.',
    'crm.asistente.dictado.red': 'No connection to the dictation service. Try again.',
    'crm.asistente.dictado.otro': 'Dictation failed. Try again.',
    'crm.asistente.quitarCaptura': 'Remove the screenshot',
    'crm.asistente.demasiadas': 'At most 6 screenshots per message.',
    'crm.asistente.pensando': 'Reading… {segundos} s',
    'crm.asistente.pensandoPie': 'With screenshots it can take up to a minute.',
    'crm.asistente.aplicar': 'Apply',
    'crm.asistente.aplicarN': 'Apply ({n})',
    'crm.asistente.descartar': 'Discard',
    'crm.asistente.aplicada': 'Applied',
    'crm.asistente.aplicadoUna': 'Done: opportunity updated.',
    'crm.asistente.aplicadoVarias': 'Done: {n} opportunities updated.',
    'crm.asistente.creadaUna': 'Done: opportunity created.',
    'crm.asistente.creadasVarias': 'Done: {n} opportunities created.',
    'crm.asistente.aplicadoMixto': 'Done: {actualizadas} updated and {creadas} new.',
    'crm.asistente.descartado': 'Discarded. Nothing was changed.',
    'crm.asistente.nota': 'Note',
    'crm.asistente.nueva': 'New opportunity',
    'crm.asistente.mover': 'Move from «{desde}» to «{hasta}»',
    'crm.asistente.tarea': 'Task: {titulo}',
    'crm.asistente.tareaVence': 'Task: {titulo} · {fecha}',
    'crm.asistente.confianzaALTA': 'Sure',
    'crm.asistente.confianzaMEDIA': 'Likely',
    'crm.asistente.confianzaBAJA': 'Unsure',
    'crm.asistente.ganada': 'Closes it as won',
    'crm.asistente.perdida': 'Closes it as lost',
    'crm.asistente.descartadas': 'Not proposed:',
    'crm.asistente.transcripcion': 'What I read in the screenshots',
    'crm.asistente.nuevo': 'New conversation',
    'crm.asistente.error': 'I could not interpret it. Please try again.',
    'crm.asistente.sinIa': 'The assistant is not set up: the AI key is missing.',
    'crm.detalle.abrir': 'Open {nombre}',
    'crm.detalle.exclusiva': 'Exclusive handling',
    'crm.detalle.nadie': 'Nobody: anyone may contact them',
    'crm.detalle.nuevaNota': 'Add a note',
    'crm.detalle.guardarNota': 'Save note',
    'crm.detalle.sinHistorial': 'No notes yet.',
    'crm.actividad.NOTA': 'Note',
    'crm.actividad.LLAMADA': 'Call',
    'crm.actividad.REUNION': 'Meeting',
    'crm.actividad.EMAIL': 'Email',
    'crm.actividad.TAREA': 'Task',
    'finreg.titulo': 'Log hours and costs',
    'finreg.horas': 'Hours',
    'finreg.gasto': 'Cost',
    'finreg.persona': 'Person',
    'finreg.yo': 'Me ({nombre})',
    'finreg.propiedad': 'Property',
    'finreg.general': '— General —',
    'finreg.fecha': 'Date',
    'finreg.tipo': 'Type',
    'finreg.tipoGESTION': 'Management',
    'finreg.tipoOTRO': 'Other',
    'finreg.registrarHoras': 'Log hours',
    'finreg.concepto': 'Item',
    'finreg.conceptoPlaceholder': 'Materials, transport…',
    'finreg.categoria': 'Category',
    'finreg.catLOGISTICA': 'Logistics',
    'finreg.catCOMPRA': 'Purchase',
    'finreg.catOTRO': 'Other',
    'finreg.coste': 'Cost (€)',
    'finreg.margen': 'Margin (%)',
    'finreg.registrarGasto': 'Log cost',
    'finreg.tarifas': 'Team rates',
    'finreg.tarifasPie': 'With no rate set, logged hours come out at 0 €. Set what each person charges: a fixed monthly amount per property, or an hourly rate.',
    'finreg.tarifasSinPropiedad': 'The rate with no property is the one applied to internal hours, and also to any house that has no rate of its own.',
    'finreg.horasInternas': 'Internal hours · no property',
    'finreg.horasInternasOpcion': '— Internal hours · no property —',
    'finreg.modalidad': 'Basis',
    'finreg.porHora': 'Per hour',
    'finreg.fijaMes': 'Fixed per month',
    'finreg.fijaMesCorto': 'Fixed/month',
    'finreg.importe': 'Amount (€)',
    'finreg.fijarTarifa': 'Set rate',
    'finreg.tarifaFijada': 'Rate set.',
    'finreg.horasRegistradas': 'Hours logged.',
    'finreg.facturaNoSubio': 'The expense was recorded, but the invoice could not be uploaded.',
    'finreg.gastoRegistrado': 'Cost logged.',
    'finreg.indicaImporte': 'Enter the rate amount.',
    'finreg.indicaHoras': 'Enter how many hours.',
    'finreg.indicaGasto': 'Enter the item and the amount.',
    'finreg.noSeFijo': 'The rate could not be set.',
    'finreg.noSeRegistraronHoras': 'The hours could not be logged.',
    'finreg.noSeRegistroGasto': 'The cost could not be logged.',
    'app.modulos': 'Modules',
    'app.navegacion': 'Navigation',
    'proy.titulo': 'Projects',
    'proy.sub': 'Teams, projects and tasks.',
    'proy.estadoTODO': 'To do',
    'proy.estadoEN_CURSO': 'In progress',
    'proy.estadoBLOQUEADA': 'Blocked',
    'proy.estadoHECHA': 'Done',
    'proy.hoy': 'Today',
    'proy.ayer': 'Yesterday',
    'proy.manana': 'Tomorrow',
    'proy.sinSeccion': 'No section',
    'proy.subtareas': 'Subtasks',
    'proy.comentarios': 'Comments',
    'proy.adjuntos': 'Attachments',
    'proy.reabrir': 'Reopen {titulo}',
    'proy.completar': 'Complete {titulo}',
    'proy.unaTarea': '{total} task',
    'proy.variasTareas': '{total} tasks',
    'proy.vista': 'View',
    'proy.lista': 'List',
    'proy.tablero': 'Board',
    'proy.buscarTarea': 'Search tasks',
    'proy.verCompletadas': 'Show completed',
    'proy.colNombre': 'Task name',
    'proy.colResponsable': 'Assignee',
    'proy.colFecha': 'Due date',
    'proy.colColaboradores': 'Collaborators',
    'proy.anadirTarea': '+ Add task',
    'proy.anadirTareaEn': 'Add a task in {seccion}',
    'proy.estadoDe': 'State of {titulo}',
    'proy.nuevaSeccion': 'New section',
    'proy.anadirSeccion': '+ Add section',
    'proy.sinEquipos': 'No teams yet. Create the first one below.',
    'proy.sinProyectos': 'No projects yet.',
    'proy.nuevoProyecto': 'New project',
    'proy.nuevoProyectoEn': 'New project in {equipo}',
    'proy.nuevoEquipo': 'New team',
    'proy.nombreEquipo': 'Team name',
    'proy.anadir': '+ Add',
    'proy.noSeCargaron': 'The projects could not be loaded.',
    'proy.noSeAbrio': 'The project could not be opened.',
    'proy.noSeCreoTarea': 'The task could not be created.',
    'proy.noSeCambio': 'The task could not be changed.',
    'proy.noSeMovio': 'The task could not be moved.',
    'proy.noSeCreoSeccion': 'The section could not be created.',
    'proy.noSeCreoProyecto': 'The project could not be created.',
    'proy.noSeCreoEquipo': 'The team could not be created.',
    'tarea.completada': '✓ Completed',
    'tarea.marcarCompletada': 'Mark completed',
    'tarea.cerrar': 'Close',
    'tarea.titulo': 'Task title',
    'tarea.responsables': 'Assignees',
    'tarea.quitarA': 'Remove {nombre}',
    'tarea.asignar': '+ Assign',
    'tarea.fecha': 'Due date',
    'tarea.prioridad': 'Priority',
    'tarea.prioALTA': 'High',
    'tarea.prioMEDIA': 'Medium',
    'tarea.prioBAJA': 'Low',
    'tarea.etiquetas': 'Tags',
    'tarea.nuevaEtiqueta': '+ tag',
    'tarea.anadirEtiqueta': 'Add a tag',
    'tarea.descripcion': 'Description',
    'tarea.subtareas': 'Subtasks',
    'tarea.anadirSubtarea': '+ Add subtask',
    'tarea.reabrir': 'Reopen {titulo}',
    'tarea.completar': 'Complete {titulo}',
    'tarea.comentarios': 'Comments',
    'tarea.sinComentarios': 'None yet.',
    'tarea.alguien': 'Someone',
    'tarea.escribeComentario': 'Write a comment',
    'tarea.noSeAbrio': 'The task could not be opened.',
    'tarea.noSeGuardo': 'The change could not be saved.',
    'tarea.noSeCambioSubtarea': 'The subtask could not be changed.',
    'tarea.noSeQuitoEtiqueta': 'The tag could not be removed.',
    'tarea.noSePusoEtiqueta': 'The tag could not be added.',
    'tarea.noSeCreoSubtarea': 'The subtask could not be created.',
    'tarea.noSePublico': 'The comment could not be posted.',
    'ia.menu': 'AI',
    'obras.entrada': 'Construction leads',
    'obras.embudos': 'Sales pipelines',
    'obras.titulo': 'Construction leads',
    'obras.sub': 'Construction under way in Mallorca that is nearing handover, and who to talk to.',
    'obras.simulacion': 'Role permissions are still simulated with the selector below; opportunities are saved for real.',
    'obras.cActivas': 'Active',
    'obras.cPendientes': 'Not contacted',
    'obras.cContacto': 'In contact',
    'obras.cFin': 'Handover soon',
    'obras.cVencidas': 'Overdue actions',
    'obras.cAlta': 'High priority',
    'obras.buscar': 'Search by name, address, area, code or contact',
    'obras.nueva': '+ New lead',
    'obras.mapa': 'Map',
    'obras.lista': 'List',
    'obras.mapaCalle': 'Street map',
    'obras.mapaSatelite': 'Satellite',
    'obras.mapaPie': 'Zoom with the + / − buttons or Ctrl and the wheel. Click a pin for the quick card; click it again to open the project.',
    'obras.verMapa': 'Show on the map',
    'obras.verLista': 'Show as a list',
    'obras.filtros': 'Filters',
    'obras.limpiar': 'Clear filters',
    'obras.atajos': 'Shortcuts',
    'obras.soloVencidas': 'Only overdue actions',
    'obras.soloAlta': 'Only high priority',
    'obras.soloFin': 'Handover within 90 days',
    'obras.soloPendientes': 'Not contacted yet',
    'obras.soloActivas': 'Hide closed',
    'obras.resultados': '{total} of {sobre}',
    'obras.zoom': 'Map zoom',
    'obras.acercar': 'Zoom in',
    'obras.alejar': 'Zoom out',
    'obras.encuadrar': 'Fit to the sites',
    'obras.mapaVacio': 'No site matches the filters.',
    'obras.mapaNota': 'Own map, no external provider. The coastline is real; the neighbourhoods are approximate and the addresses fictitious.',
    'obras.leyenda': 'How to read a marker',
    'obras.leyendaAnillo': 'Ring and number: how far the build has got',
    'obras.leyendaDistintivo': 'The badge: how the conversation is going',
    'obras.abrir': 'Open lead',
    'obras.cerrarFicha': 'Close the card',
    'obras.progreso': 'Progress',
    'obras.fase': 'Stage of works',
    'obras.finEstimada': 'Estimated completion',
    'obras.puntuacion': 'Score',
    'obras.responsable': 'Owner',
    'obras.sinResponsable': 'Unassigned',
    'obras.ultimaComprobacion': 'Last checked',
    'obras.promotorPropietario': 'Developer or owner',
    'obras.valorMercado': 'Market value',
    'obras.potencial': 'Potential for SOLUXE',
    'obras.etapaComercial': 'Sales stage',
    'obras.zona': 'Area',
    'obras.municipio': 'Municipality',
    'obras.direccion': 'Address',
    'obras.codigoPostal': 'Postcode',
    'obras.codigo': 'Code',
    'obras.tipoProyecto': 'Project type',
    'obras.confianza': 'Confidence in the estimate',
    'obras.sinDato': 'No data',
    'obras.desconocido': 'Not known yet',
    'obras.proximaAccion': 'Next action',
    'obras.sinProxima': 'No next action',
    'obras.sinProximaAviso': 'This lead is active and has nothing planned.',
    'obras.marcarHecha': 'Mark done',
    'obras.nuevaAccion': 'New action',
    'obras.quienLaHace': 'Who does it',
    'obras.cuando': 'When',
    'obras.prioridadCampo': 'Priority',
    'obras.recordatorio': 'Remind me',
    'obras.recordatorioNota': 'The reminder is internal and simulated: nothing is sent to anyone.',
    'obras.anadirAccion': 'Add action',
    'obras.descripcion': 'Description',
    'obras.porQue': 'Why this score',
    'obras.comoSeCalcula': 'A sum of seven fixed rules. No AI is involved and the result does not change between two queries.',
    'obras.pt.cerrada': 'Closed lead: not competing for attention',
    'obras.pt.finEn': 'Completion expected in {dias} days',
    'obras.pt.finPasada': 'The expected date passed {dias} days ago',
    'obras.pt.sinFecha': 'No completion date',
    'obras.pt.valor': 'Market value',
    'obras.pt.sinValor': 'Market value unknown',
    'obras.pt.decisor': 'A decision-maker is identified',
    'obras.pt.propietarioConocido': 'Owner known, decision-maker not confirmed',
    'obras.pt.sinDecisor': 'No owner or decision-maker identified',
    'obras.pt.contacto': 'A direct phone or email is available',
    'obras.pt.sinContacto': 'No usable contact details',
    'obras.pt.avance': 'The conversation has already progressed',
    'obras.pt.potencial': 'Estimated potential for SOLUXE',
    'obras.pt.sinVerificar': 'Never verified on site',
    'obras.pt.vieja': 'Unverified for {dias} days',
    'obras.prioridad.ALTA': 'High priority',
    'obras.prioridad.MEDIA': 'Medium priority',
    'obras.prioridad.BAJA': 'Low priority',
    'obras.frescura.RECIENTE': 'Up to date',
    'obras.frescura.VERIFICAR': 'Worth checking',
    'obras.frescura.DESACTUALIZADA': 'Out of date',
    'obras.frescura.SIN_VERIFICAR': 'Never verified',
    'obras.comprobar': 'Log a check',
    'obras.comprobarNota': 'What was seen',
    'obras.estadoAccion.VENCIDA': 'Overdue',
    'obras.estadoAccion.HOY': 'Due today',
    'obras.estadoAccion.PROXIMA': 'Upcoming',
    'obras.estadoAccion.SIN_ACCION': 'No action',
    'obras.fase.PREPARACION_TERRENO': 'Site preparation',
    'obras.fase.CIMENTACION': 'Foundations',
    'obras.fase.ESTRUCTURA': 'Structure',
    'obras.fase.CERRAMIENTOS': 'Envelope',
    'obras.fase.INSTALACIONES': 'Services',
    'obras.fase.ACABADOS_INTERIORES': 'Interior finishes',
    'obras.fase.EXTERIORES': 'Grounds and landscaping',
    'obras.fase.PREPARACION_ENTREGA': 'Handover preparation',
    'obras.fase.FINALIZADA': 'Completed',
    'obras.fase.DESCONOCIDO': 'Unknown',
    'obras.confianza.BAJA': 'Low',
    'obras.confianza.MEDIA': 'Medium',
    'obras.confianza.ALTA': 'High',
    'obras.etapa.DETECTADA': 'Spotted',
    'obras.etapa.INVESTIGANDO': 'Researching',
    'obras.etapa.PENDIENTE_CONTACTAR': 'To contact',
    'obras.etapa.CONTACTADA': 'Contacted',
    'obras.etapa.CONVERSACION': 'Conversation started',
    'obras.etapa.REUNION': 'Meeting booked',
    'obras.etapa.PROPUESTA': 'Proposal sent',
    'obras.etapa.GANADA': 'Won',
    'obras.etapa.PERDIDA': 'Lost',
    'obras.etapa.PAUSA': 'On hold',
    'obras.tipo.VILLA': 'Single villa',
    'obras.tipo.PROMOCION': 'Residential development',
    'obras.tipo.APARTAMENTO': 'Flat or penthouse',
    'obras.tipo.REFORMA': 'Full refurbishment',
    'obras.tipo.OTRO': 'Other',
    'obras.rol.PROPIETARIO': 'Owner',
    'obras.rol.PROMOTOR': 'Developer',
    'obras.rol.CONSTRUCTORA': 'Builder',
    'obras.rol.ARQUITECTO': 'Architect',
    'obras.rol.PROJECT_MANAGER': 'Project manager',
    'obras.rol.COMERCIALIZADORA': 'Sales agency',
    'obras.rol.AGENTE': 'Estate agent',
    'obras.rol.OTRO': 'Other contact',
    'obras.influencia.DECIDE': 'Decides',
    'obras.influencia.INFLUYE': 'Influences',
    'obras.influencia.INFORMA': 'Informs',
    'obras.canal.TELEFONO': 'Phone',
    'obras.canal.EMAIL': 'Email',
    'obras.canal.WHATSAPP': 'WhatsApp',
    'obras.canal.PRESENCIAL': 'In person',
    'obras.accionTipo.INVESTIGAR': 'Research',
    'obras.accionTipo.LLAMAR': 'Call',
    'obras.accionTipo.EMAIL': 'Send an email',
    'obras.accionTipo.WHATSAPP': 'Send a WhatsApp',
    'obras.accionTipo.VISITAR': 'Visit',
    'obras.accionTipo.PRESENTACION': 'Request a presentation',
    'obras.accionTipo.REUNION': 'Book a meeting',
    'obras.accionTipo.PROPUESTA': 'Prepare a proposal',
    'obras.accionTipo.SEGUIMIENTO': 'Follow up',
    'obras.accionTipo.VERIFICAR': 'Verify progress',
    'obras.accionTipo.OTRO': 'Other',
    'obras.apunte.CREACION': 'Lead created',
    'obras.apunte.ETAPA': 'Stage change',
    'obras.apunte.PROGRESO': 'Site update',
    'obras.apunte.CONTACTO': 'Contact',
    'obras.apunte.TAREA': 'Task',
    'obras.apunte.NOTA': 'Note',
    'obras.apunte.LLAMADA': 'Call',
    'obras.apunte.EMAIL': 'Email',
    'obras.apunte.WHATSAPP': 'WhatsApp',
    'obras.apunte.VISITA': 'Visit',
    'obras.apunte.REUNION': 'Meeting',
    'obras.apunte.CONVERSION': 'Conversion',
    'obras.colNombre': 'Site',
    'obras.colFin': 'Completion',
    'obras.ordenar': 'Sort by',
    'obras.orden.PUNTUACION': 'Score',
    'obras.orden.PROGRESO': 'Progress',
    'obras.orden.FINALIZACION': 'Completion',
    'obras.orden.VALOR': 'Value',
    'obras.orden.COMPROBACION': 'Last checked',
    'obras.orden.ACCION': 'Next action',
    'obras.nuevaTitulo': 'New construction lead',
    'obras.editar': 'Edit lead',
    'obras.gIdentificacion': 'Identification and location',
    'obras.gConstruccion': 'Construction',
    'obras.gComercial': 'Sales information',
    'obras.gSituacion': 'Situation of the property',
    'obras.nombreProvisional': 'Working name',
    'obras.nombreEjemplo': 'E.g.: Clifftop villa',
    'obras.direccionEjemplo': 'E.g.: Cami de Son Vic 14',
    'obras.eligeZona': 'Pick an area',
    'obras.situarTitulo': 'Place on the map',
    'obras.situar': 'Look up the address',
    'obras.situando': 'Searching…',
    'obras.situada': 'Placed at',
    'obras.noSituada': 'That address was not found. Type the area by hand and save anyway.',
    'obras.zonaEjemplo': 'E.g. Costa d’en Blanes',
    'obras.zonaNota': 'The area comes from looking up the address, and can also be typed. It places the project on the map.',
    'obras.origen': 'Where this came from',
    'obras.etiquetas': 'Tags',
    'obras.contactoMovil': 'Contact mobile',
    'obras.contactoEmail': 'Contact email',
    'obras.contactoNota': 'Saved as the site’s main contact. Further contacts are added on its record.',
    'obras.etiquetasNota': 'Comma separated',
    'obras.propietarioConocido': 'Owner is known',
    'obras.usoDelPropietario': 'Will be used by the owner',
    'obras.saldraAVenta': 'Will go on sale',
    'obras.yaEnVenta': 'Already on sale',
    'obras.si': 'Yes',
    'obras.no': 'No',
    'obras.guardar': 'Save lead',
    'obras.guardarCambios': 'Save changes',
    'obras.cancelar': 'Cancel',
    'obras.faltaNombre': 'Enter at least a working name and an area.',
    'obras.sinGuardar': 'There are unsaved changes.',
    'obras.errorGuardar': 'It could not be saved.',
    'obras.dupTitulo': 'This site may already be registered',
    'obras.dupExplicacion': 'It resembles something already recorded. Nothing is merged or deleted on its own: you decide.',
    'obras.dup.direccion': 'Same address',
    'obras.dup.nombre': 'Same name',
    'obras.dup.codigo': 'Same code',
    'obras.dup.promotor': 'Same developer or builder',
    'obras.dup.zona': 'Same area',
    'obras.dupAbrir': 'Open the existing one',
    'obras.dupSeguir': 'It is different, continue',
    'obras.dupCancelar': 'Cancel',
    'obras.tab.resumen': 'Overview',
    'obras.tab.fotos': 'Photos',
    'obras.tab.seguimiento': 'Activity',
    'obras.tab.contactos': 'Contacts and companies',
    'obras.tab.tareas': 'Tasks',
    'obras.tab.obra': 'Site information',
    'obras.tab.historial': 'History',
    'obras.volverLista': 'Back to leads',
    'obras.situacionFisica': 'Physical situation',
    'obras.situacionComercial': 'Sales situation',
    'obras.riesgos': 'What is still unknown',
    'obras.riesgoSinPropietario': 'The owner is not known',
    'obras.riesgoSinContacto': 'There is no phone or email',
    'obras.riesgoSinFecha': 'There is no estimated completion date',
    'obras.riesgoVieja': 'The information has not been verified for a while',
    'obras.riesgoSinValor': 'There is no estimated market value',
    'obras.sinRiesgos': 'Nothing important is missing.',
    'obras.comentarios': 'Notes about the site',
    'obras.cambiarEtapa': 'Change stage',
    'obras.comentarioEtapa': 'Note on the change',
    'obras.motivoPerdida': 'Reason it was lost',
    'obras.pidePerdida': 'Marking it lost requires a reason.',
    'obras.confirmarGanada': 'Mark as won',
    'obras.consecuenciaGanada': 'The lead closes as won and you will be offered to convert it into a client and a property.',
    'obras.registrar': 'Log',
    'obras.queHaPasado': 'What happened',
    'obras.seguimientoNota': 'It goes into the history. No real message is sent.',
    'obras.anadirContacto': 'Add contact',
    'obras.nombrePersonaEmpresa': 'Name of the person or company',
    'obras.rolEnObra': 'Role on the site',
    'obras.telefono': 'Phone',
    'obras.email': 'Email',
    'obras.web': 'Website',
    'obras.idiomaContacto': 'Language',
    'obras.canalPreferido': 'Preferred channel',
    'obras.nivelDecision': 'Level of influence',
    'obras.notas': 'Notes',
    'obras.sinContactar': 'Has asked not to be contacted',
    'obras.sinContactarAviso': 'Do not contact',
    'obras.quitarContacto': 'Remove',
    'obras.sinContactos': 'Nobody is linked to this site yet.',
    'obras.convertir': 'Convert into client and property',
    'obras.convertirTitulo': 'Convert the lead',
    'obras.convertirNota': 'Simulation: a make-believe client and property are created, linked to this lead. They disappear on reload.',
    'obras.queSeLleva': 'What gets carried over',
    'obras.llevaContactos': 'The contacts',
    'obras.llevaHistorial': 'The sales history',
    'obras.llevaObra': 'The site data',
    'obras.nombreCliente': 'Client name',
    'obras.nombrePropiedad': 'Property name',
    'obras.confirmarConversion': 'Convert',
    'obras.convertida': 'Converted into {cliente} and {propiedad}.',
    'obras.yaConvertida': 'Already converted',
    'obras.vacio': 'No sites recorded yet.',
    'obras.vacioPie': 'Add the first one with the button above.',
    'obras.sinResultados': 'No site matches what you asked for.',
    'obras.sinResultadosPie': 'Try clearing the filters.',
    'obras.reiniciar': 'Reset the demo',
    'obras.accesoDenegado': 'This module is for the sales team',
    'obras.accesoDenegadoPie': 'Your profile does not have access to construction leads.',
    'obras.permisoSimulado': 'The permissions in this module are SIMULATED in the interface. They are not a security boundary: there is no server behind them checking.',
    'obras.cargando': 'Loading opportunities…',
    'obras.noSeGuardo': 'Could not save “{obra}”. Check your connection and try again.',
    'obras.fichas': 'Field sheets',
    'obras.fichasTitulo': 'Field sheets',
    'obras.fichasSub': 'Upload photos of the day’s sheets and they are read one by one.',
    'obras.fichasSubir': 'Photos of the sheets',
    'obras.fichasNota': 'Each photo comes back as a draft to review. Nothing is created on its own: you save it, with the usual form.',
    'obras.fichasLeyendo': 'Reading {total} sheet(s)…',
    'obras.fichaLeyendo': 'Reading…',
    'obras.fichaNoSeLeyo': 'This sheet could not be read.',
    'obras.fichaSinNombre': 'No name on the sheet',
    'obras.fichaCamposLeidos': '{total} field(s) read from the paper:',
    'obras.fichaDudas': 'Not understood:',
    'obras.fichaRevisar': 'Review and create',
    'obras.campoNombre': 'Name',
    'obras.campoDireccion': 'Address',
    'obras.campoCp': 'Postcode',
    'obras.campoMunicipio': 'Municipality',
    'obras.campoZona': 'Area',
    'obras.campoTipo': 'Project type',
    'obras.campoFase': 'Stage of works',
    'obras.campoProgreso': 'Progress',
    'obras.campoFin': 'Completion',
    'obras.campoConfianza': 'Confidence',
    'obras.campoComentario': 'Comment',
    'obras.campoEtapa': 'Pipeline stage',
    'obras.campoResponsable': 'Owner',
    'obras.campoValor': 'Market value',
    'obras.campoContactos': 'Contacts',
    'obras.promotor': 'Developer',
    'obras.promotorEjemplo': 'E.g.: Son Vida Developments SL',
    'obras.guardando': 'Saving…',
    'fotos.adjuntar': 'Attach photos (JPG or PNG, one or more)',
    'fotos.altaNota': 'They are uploaded when the opportunity is saved, with today’s date and your name, so photos added in a few months can be compared to see how the works have progressed.',
    'fotos.alGuardar': 'Uploads on save',
    'fotos.guardandoConFotos': 'Saving and uploading photos…',
    'fotos.noSubieron': 'The opportunity was saved, but {total} photo(s) could not be uploaded. Add them from the Photos tab.',
    'obras.simularRol': 'Simulate role',
    'obras.rolDireccion': 'Management',
    'obras.rolComercial': 'Sales',
    'obras.rolOtro': 'Client or provider',
    'obras.soloLectura': 'Read only: this lead is not assigned to you.',
    'nivelIncidencia.1': 'Emergency',
    'nivelIncidencia.2': 'Priority',
    'nivelIncidencia.3': 'Scheduled',
    'nivelIncidencia.4': 'Cosmetic improvement',
    'estadoIncidencia.OPEN': 'Open',
    'estadoIncidencia.IN_PROGRESS': 'In progress',
    'estadoIncidencia.CLOSED': 'Closed',
    'estadoIncidencia.CANCELLED': 'Cancelled',
    'tipoDocumento.CONTRATO': 'Agreement',
    'tipoDocumento.SEGURO': 'Insurance',
    'tipoDocumento.GARANTIA': 'Warranty',
    'tipoDocumento.FACTURA': 'Invoice',
    'tipoDocumento.OTRO': 'Other',
    'areaMant.GESTION': 'Management',
    'frecuencia.SEMANAL': 'Weekly',
    'frecuencia.QUINCENAL': 'Fortnightly',
    'frecuencia.MENSUAL': 'Monthly',
    'frecuencia.TRIMESTRAL': 'Quarterly',
    'frecuencia.SEMESTRAL': 'Half-yearly',
    'frecuencia.ANUAL': 'Yearly',
    'frecuencia.PERSONALIZADA': 'Custom',
    'ficha.genera': 'Creates',
    'ficha.antelacion': '{total}d lead time',
    'estadoEstancia.PREVISTA': 'Scheduled',
    'estadoEstancia.EN_CURSO': 'In progress',
    'estadoEstancia.FINALIZADA': 'Finished',
    'estadoEstancia.CANCELADA': 'Cancelled',
    'ficha.resumen': 'Overview',
    'ficha.buscarIncidencia': 'Search issues',
    'ficha.incidencias': 'Issues',
    'ficha.visitas': 'Visits',
    'ficha.mantenimiento': 'Maintenance',
    'ficha.proveedores': 'Providers',
    'ficha.gastos': 'Expenses',
    'ficha.contratos': 'Agreements',
    'ficha.historial': 'History',
    'ficha.proximaVisita': 'Next visit',
    'ficha.ultimaVisita': 'Last visit',
    'ficha.visitasVencidas': '{total} overdue visits',
    'ficha.sinVisitas': 'No visits yet',
    'ficha.incidenciasActivas': 'Open issues',
    'ficha.gastoAcumulado': 'Total spend',
    'ficha.horasCol': 'Hours',
    'ficha.horasImputadas': '{total} h logged',
    'ficha.estancias': 'Client stays',
    'ficha.confirmarQuitarEstancia': 'Remove the stay {cuando}? It is voided, not deleted.',
    'ficha.sinEstancias': 'No stays recorded.',
    'ficha.llegada': 'Arrival',
    'ficha.salida': 'Departure',
    'ficha.huesped': 'Guest',
    'ficha.registrarEstancia': 'Record stay',
    'ficha.fotos': 'Property photos',
    'ficha.sinFotos': 'No photos yet.',
    'ficha.anadirFoto': 'Add photo',
    'ficha.urlFoto': 'Image address',
    'ficha.fotoPorUrl': 'For now the image address is stored; file upload is a separate piece.',
    'ficha.tarifasEquipo': 'Team rates',
    'ficha.rol': 'Role',
    'ficha.porHora': 'EUR/hour',
    'ficha.fijaMensual': 'Fixed rate/month',
    'ficha.tarifaPrioridad': 'The fixed monthly rate takes precedence over the hourly one.',
    'ficha.mantenimientoExplicacion': 'Preventive work repeats on a cadence; marking it done recalculates the next date.',
    'ficha.sinMantenimiento': 'No scheduled maintenance.',
    'ficha.cadaDias': 'every {total} days',
    'ficha.puntual': 'one-off',
    'ficha.proxima': 'Next',
    'ficha.marcarHecho': 'Mark done',
    'ficha.concepto': 'Task',
    'ficha.cadenciaDias': 'Cadence (days)',
    'ficha.anadirMantenimiento': 'Add maintenance',
    'ficha.proveedoresExplicacion': 'The regular providers for this property, so you do not look them up each time.',
    'ficha.sinProveedores': 'No providers linked.',
    'ficha.vincularProveedor': 'Link provider',
    'ficha.vincular': 'Link',
    'ficha.desvincular': 'Unlink',
    'ficha.gastosMesActual': 'Expenses charged to this property this month.',
    'acceso.lema': 'All supervised by our own team, to a single standard of quality.',
    'acceso.sub': 'End-to-end property management — visits, issues and assets under one key.',
    'acceso.bienvenido': 'Welcome back',
    'acceso.entrar': 'Sign in',
    'areaMant.INTERIOR': 'Interior',
    'areaMant.EXTERIOR': 'Exterior',
    'areaMant.SISTEMAS': 'Systems',
    'areaMant.PISCINA': 'Pool',
    'areaMant.JARDIN': 'Garden',
    'areaMant.OTRO': 'Other',
    'estadoEvento.PREVISTA': 'Open',
    'estadoEvento.EN_CURSO': 'In progress',
    'estadoEvento.HECHA': 'Closed',
    'estadoEvento.CANCELADA': 'Cancelled',
    'ficha.ocupada': 'Occupied',
    'ficha.casaVacia': 'House empty',
    'ficha.sinSalida': 'No checkout date',
    'ficha.confirmarQuitarDocumento': 'Remove «{titulo}»? The file goes with it.',
    'visita.enCursoNoSeQuita': 'That visit is being walked right now. Finish or abandon it, then remove it from the calendar.',
    'ajustes.categoriaRepetida': 'A category with that name already exists.',
    'ajustes.categoriaEnUso': 'That category has expenses on it: deactivate it instead of deleting it, and the old expenses will still add up.',
    'ajustes.categoriaDelSistema': 'That category belongs to the system: it can be renamed and deactivated, but not deleted.',
    'estancia.enCurso': 'That stay is under way.',
    'visita.exigeFoto': 'That item needs a photo: take it and then mark the item.',
    'visita.pideFoto': 'Photo required',
    'visita.anadirFoto': 'Photo',
    'visita.faltanFotos': 'You cannot close the visit: some points that require a photo are unresolved. Take the photo, or mark them “Not applicable”.',
    'visita.hacerFoto': 'Take the photo',
    'visita.reabrir': 'Reopen the visit',
    'visita.reabrirPie': 'To add or remove photos and correct what was marked.',
    'visita.subiendoFoto': 'Uploading…',
    'visita.quitar': 'Remove from the calendar',
    'visita.confirmarQuitar': 'Remove «{titulo}» from the calendar?',
    'interno.titulo': 'Internal',
    'interno.subtitulo': 'Team expenses and hours, with no property',
    'interno.subtituloPropio': 'Your own history of hours and expenses. Yours only.',
    'interno.total': 'Total spent',
    'interno.registros': '{total} records',
    'interno.pendientes': 'Awaiting approval',
    'interno.pendientesPie': 'awaiting a decision',
    'interno.sinContabilizar': 'Not in accounting',
    'interno.sinContabilizarPie': 'not posted to accounting',
    'interno.horas': 'Hours',
    'interno.gastos': 'Expenses',
    'interno.categoria': 'Category',
    'interno.estado': 'Status',
    'interno.todasCategorias': 'All categories',
    'interno.todosEstados': 'All statuses',
    'interno.vacio': 'No records.',
    'interno.fecha': 'Date',
    'gasto.factura': 'Invoice',
    'gasto.verFactura': 'View the expense invoice',
    'gasto.sinFactura': 'This expense has no invoice attached. Upload it here.',
    'gasto.adjuntarFactura': 'Upload the invoice (image or PDF)',
    'gasto.adjuntarOtra': 'Add another (image or PDF)',
    'gasto.formatosFactura': 'JPG, PNG, HEIC or PDF. Up to 20 MB.',
    'gasto.subiendo': 'Uploading…',
    'gasto.noSeSubio': 'The invoice could not be uploaded. Please try again.',
    'gasto.abrirAparte': 'Open in a new tab',
    'carga.editar': 'Edit',
    'carga.eliminar': 'Remove',
    'carga.acciones': 'Actions',
    'carga.editarGasto': 'Edit expense',
    'carga.editarHoras': 'Edit time entry',
    'carga.confirmarGasto': 'Remove “{concepto}”? It will stop counting for the month and for billing.',
    'carga.confirmarHoras': 'Remove this {horas} entry? It will stop counting for the month and for pay.',
    'carga.guardar': 'Save changes',
    'carga.noSeGuardo': 'The changes could not be saved.',
    'carga.noSeQuito': 'It could not be removed.',
    'carga.horas': 'Hours',
    'carga.sinPropiedad': 'Internal (no property)',
    'interno.ambito': 'Which entries to show',
    'interno.ambitoInterno': 'Team’s own (no property)',
    'interno.ambitoCasas': 'Charged to properties',
    'interno.ambitoTodo': 'All',
    'interno.propiedad': 'Property',
    'fotos.titulo': 'Photos',
    'fotos.subir': 'Upload photos',
    'fotos.subiendo': 'Uploading {total} file(s)…',
    'fotos.noSeSubio': 'Could not upload “{fichero}”.',
    'fotos.quitar': 'Remove photo',
    'fotos.confirmarQuitar': 'Remove this photo? This cannot be undone.',
    'fotos.noSeQuito': 'The photo could not be removed.',
    'fotos.sinAutor': 'No author',
    'fotos.vacio': 'No photos yet.',
    'fotos.vacioPuede': 'No photos yet. Upload the first one with the button above.',
    'fotos.obra': 'Site photos',
    'fotos.obraNota': 'Each photo keeps who uploaded it and when, so comparing them shows how the works are progressing.',
    'fotos.tarea': 'Images',
    'interno.concepto': 'Description',
    'interno.beneficiario': 'Paid to',
    'interno.contab': 'Posted',
    'interno.contabSi': 'Yes',
    'interno.contabNo': 'No',
    'interno.importe': 'Amount',
    'interno.persona': 'Person',
    'interno.tipo': 'Type',
    'interno.descripcion': 'Notes',
    'interno.horasCol': 'Hours',
    'estadoGasto.PENDIENTE_APROBACION': 'Pending approval',
    'estadoGasto.APROBADO': 'Approved',
    'estadoGasto.RECHAZADO': 'Rejected',
    'estadoGasto.PAGADO': 'Paid',
    'categoriaGasto.LOGISTICA': 'Logistics',
    'categoriaGasto.COMPRA': 'Purchase',
    'categoriaGasto.OTRO': 'Other',
    'categoriaGasto.MARKETING': 'Marketing',
    'categoriaGasto.VEHICULOS': 'Vehicles / fuel',
    'categoriaGasto.PROPERTY_MANAGEMENT': 'Property management costs',
    'categoriaGasto.OFICINA': 'Office',
    'categoriaGasto.PROVEEDORES_CLIENTES': 'Client-linked suppliers',
    'categoriaGasto.EQUIPO': 'Team',
    'categoriaGasto.GASTOS_GENERALES': 'General expenses',
    'categoriaGasto.REAL_ESTATE': 'Real estate costs',
    'categoriaGasto.SOFTWARE': 'Software',
    'categoriaGasto.SERVICIOS': 'Services',
    'categoriaGasto.RECUPERABLES': 'Recoverable costs',
    'categoriaGasto.LIMPIEZA': 'Cleaning',
    'categoriaGasto.GESTORIA': 'Accounting / legal / admin',
    'categoriaGasto.OTROS_DIRECTOS': 'Other direct costs',
    'tipoHora.GESTION': 'Management',
    'tipoHora.OTRO': 'Other',
    'tipoHora.MANTENIMIENTO': 'Maintenance',
    'tipoHora.LIMPIEZA': 'Cleaning',
    'tipoHora.OBRA': 'Building works',
    'tipoHora.ADMINISTRACION': 'Administration',
    'tipoHora.COMERCIAL': 'Sales',
    'tipoHora.DESPLAZAMIENTO': 'Travel',
    'estadoPropiedad.ONBOARDING': 'Onboarding',
    'estadoPropiedad.ACTIVE': 'Active',
    'estadoPropiedad.SUSPENDED': 'Suspended',
    'estadoPropiedad.INTERNAL_DEMO': 'Internal or demo',
    'estadoPropiedad.ARCHIVED': 'Archived',
    'requisito.DIRECCION': 'Address',
    'requisito.ZONA': 'Area',
    'requisito.PROPIETARIO': 'At least one owner',
    'requisito.CONTRATO': 'Active management agreement',
    'requisito.CLIENTE_FACTURACION': 'Billing customer',
    'requisito.TARIFA': 'Current fee',
    'requisito.NIO_VALIDADA': 'Validated service assessment',
    'requisito.RESPONSABLE_INTERNO': 'Internal owner',
    'semaforo.VERDE': 'On track',
    'semaforo.AMARILLO': 'Needs attention',
    'semaforo.ROJO': 'At risk',
    'rol.DIRECTOR': 'Director',
    'rol.MANAGER': 'Manager',
    'rol.PROVEEDOR': 'Vendor',
    'rol.CLIENTE': 'Client',
    'rol.PROMOTOR': 'Developer',
    'portal.soloMirar': 'You are viewing this property as an observer: you can see everything, but not log or write anything.',
    'rol.CAPTADOR': 'Canvasser',
    'crm.pipelines': 'Pipelines',
    'crm.pipelinesPie': 'The usual sales funnel: opportunities by stage.',
    'crm.obras': 'Construction leads',
    'crm.obrasPie': 'Builds under way that may become managed homes.',
    'pap.titulo': 'Door to door',
    'pap.sub': 'Street work: which roads we covered and how it went.',
    'pap.registrar': 'Log a door',
    'pap.nuevaPuerta': 'New door',
    'pap.estoyAqui': 'I am here',
    'pap.ubicando': 'Finding the address…',
    'pap.sinGps': 'This device gives no location. Type the address.',
    'pap.noSePudoUbicar': 'Could not read the location. Type the address.',
    'pap.direccion': 'Address',
    'pap.zona': 'Area',
    'pap.municipio': 'Town',
    'pap.codigoPostal': 'Postcode',
    'pap.situarTitulo': 'Exactly where it is',
    'pap.situarPie': 'Tap the map or drag the pin onto the house. It is stored when you press Save.',
    'pap.atendieron': 'Did anyone answer?',
    'pap.queDijeron': 'What did they say?',
    'pap.respuestaOtra': 'Write it in your own words',
    'pap.contacto': 'Contact name',
    'pap.contactoPie': 'Optional',
    'pap.telefono': 'Phone',
    'pap.notas': 'Notes',
    'pap.material': 'Material left',
    'pap.fotos': 'Photos',
    'pap.fotosPie': 'The front, and anything neglected: garden, gate, pool.',
    'pap.hacerFoto': 'Take a photo',
    'pap.anadirFoto': 'Add photo',
    'pap.subiendo': 'Uploading…',
    'pap.fotosElegidas': '{total} photos ready',
    'pap.fotosGuardadas': '{total} photos saved to the record',
    'pap.fotosPerdidas': '{total} photos could not be uploaded. The door was logged; add them from its record.',
    'pap.guardar': 'Save and continue',
    'pap.guardando': 'Saving…',
    'pap.guardada': 'Door logged',
    'pap.siguiente': 'Next door',
    'pap.terminar': 'Finish',
    'pap.mapa': 'Map of what we covered',
    'pap.vista.mapa': 'Map',
    'pap.vista.zonas': 'Areas',
    'pap.vista.lista': 'List',
    'pap.buscar': 'Search street, area or name',
    'pap.todas': 'All',
    'pap.estadoTitulo': 'Status',
    'pap.estado.ATENDIO': 'Answered',
    'pap.estado.NO_ATENDIO': 'No answer',
    'pap.estado.SEGUIMIENTO': 'Follow up',
    'pap.estado.DESCARTADA': 'Dropped',
    'pap.estado.CLIENTE': 'Now a client',
    'pap.respuesta.YA_TIENE_GESTOR': 'Already has someone managing it',
    'pap.respuesta.NO_INTERESA': 'Not interested',
    'pap.respuesta.DEJA_INFORMACION': 'Leave me information',
    'pap.respuesta.LLAMA_MAS_ADELANTE': 'Call me later on',
    'pap.respuesta.SEGUNDA_RESIDENCIA': 'It is a second home',
    'pap.respuesta.NO_ES_PROPIETARIO': 'Not the owner',
    'pap.respuesta.QUIERE_INFORMACION': 'Wants information',
    'pap.respuesta.OTRA': 'Other',
    'pap.material.FLYER': 'Flyer',
    'pap.material.TARJETA': 'Card',
    'pap.material.AMBOS': 'Both',
    'pap.material.NINGUNO': 'Nothing',
    'pap.seguimientos': 'Follow-ups and tasks',
    'pap.nuevoSeguimiento': 'What needs doing here',
    'pap.sinSeguimientos': 'Nothing pending at this door.',
    'pap.historial': 'History',
    'pap.sinHistorial': 'Nothing has happened yet.',
    'pap.zonasRecorridas': 'Areas covered',
    'pap.zonaResumen': '{puertas} doors · {atendidas} with an answer',
    'pap.vacio': 'No doors logged yet.',
    'pap.sinEnEsteFiltro': 'Nothing here.',
    'pap.noSeCargaron': 'The doors could not be loaded.',
    'pap.confirmarQuitar': 'Remove this door? This cannot be undone.',
    'party.titulo': 'People and companies',
    'party.vacio': 'No people or companies yet.',
    'party.nueva': 'New person or company',
    'party.editar': 'Edit',
    'party.tipo': 'Type',
    'party.pais': 'Country (ISO)',
    'party.nif': 'Tax ID',
    'party.nifSoloFacturacion': 'Only needed if they will be invoiced',
    'party.direccionFacturacion': 'Billing address',
    'party.telefono': 'Phone',
    'party.PERSONA_FISICA': 'Individual',
    'party.EMPRESA': 'Company',
    'party.COMUNIDAD_PROPIETARIOS': 'Homeowners association',
    'party.OTRA_ENTIDAD_JURIDICA': 'Other legal entity',
    'party.archivada': 'This record is archived.',
    'party.datosFacturacionIncompletos': 'Billing details are incomplete: tax ID, email or billing address.',
    'party.enUso': 'Cannot archive: it still has active agreements or relationships.',
    'relacion.OWNER': 'Owner',
    'relacion.PROMOTER': 'Developer',
    'relacion.ASSET_MANAGER': 'Managing company',
    'relacion.AUTHORIZED_CONTACT': 'Authorised contact',
    'relacion.vacio': 'No relationships yet.',
    'relacion.rol': 'Acting as',
    'relacion.desde': 'From',
    'relacion.anadir': 'Add relationship',
    'relacion.finalizar': 'End',
    'relacion.motivoFin': 'Reason for ending',
    'relacion.historicas': 'Past relationships',
    'contrato.titulo': 'Management agreement',
    'contrato.vacio': 'No agreement yet.',
    'contrato.DRAFT': 'Draft',
    'contrato.ACTIVE': 'Active',
    'contrato.TERMINATED': 'Terminated',
    'contrato.crear': 'Create agreement',
    'contrato.desde': 'Start date',
    'contrato.moneda': 'Currency',
    'contrato.umbral': 'Client approval threshold',
    'contrato.tarifa': 'Fee',
    'contrato.importe': 'Amount',
    'contrato.importeOpcional': 'optional: the suggested fee is used',
    'contrato.modalidadTarifa': 'Fee mode',
    'contrato.fijarTarifa': 'Set fee',
    'contrato.activar': 'Activate agreement',
    'contrato.congelada': 'amount frozen on activation',
    'contrato.historicos': 'Past agreements',
    'contrato.finalizar': 'End agreement',
    'contrato.hasta': 'Effective end date',
    'contrato.motivoFin': 'Reason for ending it',
    'contrato.finalizarConsecuencias': 'The agreement ends on that date and its fee stops being current the same day. If the property is active, it becomes suspended in the same operation. Nothing is deleted: the agreement and its fee stay in the record.',
    'contrato.clienteFacturacion': 'Billing customer',
    'contrato.modalidad.MANUAL': 'Manual fee',
    'contrato.modalidad.NIO': 'Service-level fee',
    'contrato.tarifaCongelada': 'The fee of an active agreement is frozen.',
    'contrato.nioNoValidada': 'A service-level fee requires a validated assessment.',
    'contrato.nioDeOtraPropiedad': 'That assessment belongs to a different property.',
    'contrato.estadoInvalido': 'The agreement is not in a state that allows this action.',
    'contrato.sinPagador': 'The billing customer is missing.',
    'contrato.sinTarifa': 'The fee is missing.',
    'propiedad.estadoSinCambio': 'The property is already in that status.',
    'propiedad.transicionNoPermitida': 'That status change is not allowed.',
    'propiedad.motivoObligatorio': 'This status change requires a reason.',
    'propiedad.requisitosPendientes': 'Some requirements are still missing.',
    'propiedad.incidenciasAbiertas': 'There are open issues: close or cancel them first.',
    'propiedad.noOperativa': 'The property is not in service.',
    'propiedad.contratoVigente': 'There is a current agreement: end it before archiving.',
    'cicloVida.titulo': 'Lifecycle',
    'cicloVida.suspender': 'Suspend property',
    'cicloVida.reactivar': 'Reactivate property',
    'cicloVida.archivar': 'Archive property',
    'cicloVida.motivo': 'Reason',
    'cicloVida.suspenderConsecuencias': 'It stops being in service. The agreement stays current and its fee is untouched: suspending does not end it. It can be reactivated.',
    'cicloVida.reactivarConsecuencias': 'It returns to service. Requires a current agreement and every requirement met.',
    'cicloVida.archivarConsecuencias': 'It leaves the portfolio for good. Requires a reason, no open issues and no current agreement. The whole record is kept, but this property is no longer operated.',
    'cicloVida.archivada': 'Property archived. Its whole record is kept. It can be restored: it returns to onboarding with the same file.',
    'cicloVida.restaurar': 'Restore property',
    'cicloVida.restaurarConsecuencias': 'It returns to onboarding with the same identifier, its relationships and its whole history. No new record is created. To be active again it must meet every requirement once more and have a current agreement.',
    'nio.titulo': 'Service assessment',
    'nio.vacio': 'No assessment yet.',
    'nio.nueva': 'New assessment',
    'nio.sustituir': 'Supersede with a new one',
    'nio.editar': 'Edit draft',
    'nio.validar': 'Validate',
    'nio.total': 'Total',
    'nio.yaHayBorrador': 'There is already a draft for this property.',
    'nio.explicacion': 'Operational intensity level: calculated from six factors scored 1 to 5, it sets the suggested fee.',
    'nio.factorInvalido': 'Each factor must be a whole number between 1 and 5.',
    'nio.sinTablaBase': 'No base rate table has been configured.',
    'nio.soloBorradorEditable': 'Only a draft can be edited.',
    'nio.estadoInvalido': 'The assessment is not in a state that allows this action.',
    'nio.BORRADOR': 'Draft',
    'nio.VALIDADA': 'Validated',
    'nio.SUSTITUIDA': 'Superseded',
    'nio.cuotaSugerida': 'Suggested fee',
    'nio.factor.valorActivo': 'Asset value',
    'nio.factor.complejidadTecnica': 'Technical complexity',
    'nio.factor.frecuenciaUso': 'Frequency of use',
    'nio.factor.exigenciaCliente': 'Client demand level',
    'nio.factor.exposicionClimatica': 'Weather exposure',
    'nio.factor.historialIntervencion': 'History and intervention',
    'incidencia.titulo': 'Issues',
    'incidencia.vacio': 'No issues.',
    'incidencia.crear': 'Log issue',
    'incidencia.descripcion': 'Description',
    'incidencia.acciones': 'Actions',
    'incidencia.cerrar': 'Close',
    'incidencia.anular': 'Cancel issue',
    'incidencia.resolucion': 'Resolution',
    'incidencia.motivo': 'Reason',
    'incidencia.OPEN': 'Open',
    'incidencia.IN_PROGRESS': 'In progress',
    'incidencia.CLOSED': 'Closed',
    'incidencia.CANCELLED': 'Cancelled',
    'incidencia.estadoInvalido': 'The issue is not in a state that allows this action.',
    'incidencia.sugerencia': 'The AI suggests L{nivel} — {nombre}.',
    'incidencia.usarSugerencia': 'Use it',
    'incidencia.agregar': 'Add incident',
    'incidencia.tituloCampo': 'Title',
    'incidencia.area': 'Area',
    'incidencia.costeEstimado': 'Estimated cost (€)',
    'incidencia.fotos': 'Images',
    'incidencia.anadirFotos': '📷 Add images',
    'incidencia.quitarFoto': 'Remove this image',
    'incidencia.nivel': 'Level',
    'incidencia.nivel.1': 'Emergency',
    'incidencia.nivel.2': 'Priority',
    'incidencia.nivel.3': 'Scheduled',
    'incidencia.nivel.4': 'Cosmetic improvement',
    'idioma.es': 'Spanish',
    'idioma.en': 'English',
    'idioma.de': 'German',
};
//# sourceMappingURL=en.js.map